(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("vue-markdown"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue", "vue-markdown"], factory);
	else if(typeof exports === 'object')
		exports["csclient"] = factory(require("Vue"), require("vue-markdown"));
	else
		root["csclient"] = factory(root["Vue"], root["vue-markdown"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_vue_markdown__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/axios/index.js":
/*!*******************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/index.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/axios */ "../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/*!******************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/adapters/xhr.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "../../node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(/*! ./../helpers/btoa */ "../../node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("development" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/*!***********************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/axios.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/Cancel.js":
/*!*******************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/cancel/Cancel.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/*!************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/cancel/CancelToken.js ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/*!*********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/cancel/isCancel.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/*!****************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/Axios.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/*!*****************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/InterceptorManager.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../node_modules/axios/lib/core/createError.js":
/*!**********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/createError.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/*!**************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/dispatchRequest.js ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/enhanceError.js":
/*!***********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/enhanceError.js ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/*!*****************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/settle.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/*!************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/core/transformData.js ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../node_modules/axios/lib/defaults.js":
/*!**************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/defaults.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(/*! ./utils */ "../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/process/browser.js */ "../../node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/*!******************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/bind.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/btoa.js":
/*!******************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/btoa.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/*!**********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/buildURL.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/*!*************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/combineURLs.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/*!*********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/cookies.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!***************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!*****************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!*********************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!**************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/parseHeaders.js ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/*!********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/helpers/spread.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/*!***********************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/axios/lib/utils.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../node_modules/css-element-queries/src/ResizeSensor.js":
/*!********************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-element-queries/src/ResizeSensor.js ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
;
(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {

    //Make sure it does not throw in a SSR (Server Side Rendering) situation
    if (typeof window === "undefined") {
        return null;
    }
    // Only used for the dirty checking, so the event callback count is limted to max 1 call per fps per sensor.
    // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
    // would generate too many unnecessary events.
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (fn) {
            return window.setTimeout(fn, 20);
        };

    /**
     * Iterate over each of the provided element(s).
     *
     * @param {HTMLElement|HTMLElement[]} elements
     * @param {Function}                  callback
     */
    function forEachElement(elements, callback){
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = ('[object Array]' === elementsType
            || ('[object NodeList]' === elementsType)
            || ('[object HTMLCollection]' === elementsType)
            || ('[object Object]' === elementsType)
            || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
            || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
        );
        var i = 0, j = elements.length;
        if (isCollectionTyped) {
            for (; i < j; i++) {
                callback(elements[i]);
            }
        } else {
            callback(elements);
        }
    }

    /**
     * Class for dimension change detection.
     *
     * @param {Element|Element[]|Elements|jQuery} element
     * @param {Function} callback
     *
     * @constructor
     */
    var ResizeSensor = function(element, callback) {
        /**
         *
         * @constructor
         */
        function EventQueue() {
            var q = [];
            this.add = function(ev) {
                q.push(ev);
            };

            var i, j;
            this.call = function() {
                for (i = 0, j = q.length; i < j; i++) {
                    q[i].call();
                }
            };

            this.remove = function(ev) {
                var newQueue = [];
                for(i = 0, j = q.length; i < j; i++) {
                    if(q[i] !== ev) newQueue.push(q[i]);
                }
                q = newQueue;
            }

            this.length = function() {
                return q.length;
            }
        }

        /**
         * @param {HTMLElement} element
         * @param {String}      prop
         * @returns {String|Number}
         */
        function getComputedStyle(element, prop) {
            if (element.currentStyle) {
                return element.currentStyle[prop];
            } else if (window.getComputedStyle) {
                return window.getComputedStyle(element, null).getPropertyValue(prop);
            } else {
                return element.style[prop];
            }
        }

        /**
         *
         * @param {HTMLElement} element
         * @param {Function}    resized
         */
        function attachResizeEvent(element, resized) {
            if (!element.resizedAttached) {
                element.resizedAttached = new EventQueue();
                element.resizedAttached.add(resized);
            } else if (element.resizedAttached) {
                element.resizedAttached.add(resized);
                return;
            }

            element.resizeSensor = document.createElement('div');
            element.resizeSensor.className = 'resize-sensor';
            var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
            var styleChild = 'position: absolute; left: 0; top: 0; transition: 0s;';

            element.resizeSensor.style.cssText = style;
            element.resizeSensor.innerHTML =
                '<div class="resize-sensor-expand" style="' + style + '">' +
                    '<div style="' + styleChild + '"></div>' +
                '</div>' +
                '<div class="resize-sensor-shrink" style="' + style + '">' +
                    '<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
                '</div>';
            element.appendChild(element.resizeSensor);

            if (getComputedStyle(element, 'position') == 'static') {
                element.style.position = 'relative';
            }

            var expand = element.resizeSensor.childNodes[0];
            var expandChild = expand.childNodes[0];
            var shrink = element.resizeSensor.childNodes[1];
            var dirty, rafId, newWidth, newHeight;
            var lastWidth = element.offsetWidth;
            var lastHeight = element.offsetHeight;

            var reset = function() {
                expandChild.style.width = '100000px';
                expandChild.style.height = '100000px';

                expand.scrollLeft = 100000;
                expand.scrollTop = 100000;

                shrink.scrollLeft = 100000;
                shrink.scrollTop = 100000;
            };

            reset();

            var onResized = function() {
                rafId = 0;

                if (!dirty) return;

                lastWidth = newWidth;
                lastHeight = newHeight;

                if (element.resizedAttached) {
                    element.resizedAttached.call();
                }
            };

            var onScroll = function() {
                newWidth = element.offsetWidth;
                newHeight = element.offsetHeight;
                dirty = newWidth != lastWidth || newHeight != lastHeight;

                if (dirty && !rafId) {
                    rafId = requestAnimationFrame(onResized);
                }

                reset();
            };

            var addEvent = function(el, name, cb) {
                if (el.attachEvent) {
                    el.attachEvent('on' + name, cb);
                } else {
                    el.addEventListener(name, cb);
                }
            };

            addEvent(expand, 'scroll', onScroll);
            addEvent(shrink, 'scroll', onScroll);
        }

        forEachElement(element, function(elem){
            attachResizeEvent(elem, callback);
        });

        this.detach = function(ev) {
            ResizeSensor.detach(element, ev);
        };
    };

    ResizeSensor.detach = function(element, ev) {
        forEachElement(element, function(elem){
            if(elem.resizedAttached && typeof ev == "function"){
                elem.resizedAttached.remove(ev);
                if(elem.resizedAttached.length()) return;
            }
            if (elem.resizeSensor) {
                if (elem.contains(elem.resizeSensor)) {
                    elem.removeChild(elem.resizeSensor);
                }
                delete elem.resizeSensor;
                delete elem.resizedAttached;
            }
        });
    };

    return ResizeSensor;

}));


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/assets/fonts/fonts.css":
/*!********************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/assets/fonts/fonts.css ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/url/escape.js */ "../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/* fallback */\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url(" + escape(__webpack_require__(/*! ./flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2 */ "./src/assets/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2")) + ") format('woff2');\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fCRc4EsA.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fABc4EsA.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fCBc4EsA.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fBxc4EsA.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fCxc4EsA.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fChc4EsA.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fBBc4.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu72xKOzY.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu5mxKOzY.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu7mxKOzY.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4WxKOzY.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu7WxKOzY.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu7GxKOzY.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto'), local('Roboto-Regular'), url(" + escape(__webpack_require__(/*! ./KFOmCnqEu92Fr1Mu4mxK.woff2 */ "./src/assets/fonts/KFOmCnqEu92Fr1Mu4mxK.woff2")) + ") format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fABc4EsA.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fCBc4EsA.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fBxc4EsA.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fCxc4EsA.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fChc4EsA.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Roboto Medium'), local('Roboto-Medium'), url(" + escape(__webpack_require__(/*! ./KFOlCnqEu92Fr1MmEU9fBBc4.woff2 */ "./src/assets/fonts/KFOlCnqEu92Fr1MmEU9fBBc4.woff2")) + ") format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfABc4EsA.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfCBc4EsA.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfBxc4EsA.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfCxc4EsA.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Roboto Bold'), local('Roboto-Bold'), url(" + escape(__webpack_require__(/*! ./KFOlCnqEu92Fr1MmWUlfBBc4.woff2 */ "./src/assets/fonts/KFOlCnqEu92Fr1MmWUlfBBc4.woff2")) + ") format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/components/cs-app/cs-app.css":
/*!**************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/components/cs-app/cs-app.css ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".cstabs {\n  margin-top: 0px;\n}\n\n.cs-navigation-tabbar .tabs__bar\n{\n  background-color: transparent !important\n}\n\n.menu {\n  background-color: red;\n}\n\n.app-menu{\n  color: red !important\n  /** margin-left:5px; */\n}\n\n\n.header-title-container {\n  margin-left: 16px;\n}\n\n@media only screen and (max-width: 480px) {\n  .header-breadcrumbs {\n    display: none !important;\n  }\n}\n\n.sidebar {\n  /* z-index:200 !important; */\n}\n\n.header-breadcrumbs {\n  padding: 0 !important;\n}\n\n.breadcrumbs__item {\n  color:hsla(0,0%,100%,.5);\n}\n\n.header-breadcrumbs>li {\n  padding: 0 !important;\n}\n\n.header-title {\n  margin-left: 0 !important;\n}\n\n.floating {\n  margin-top: -48px !important;\n}\n\n.leftsidebar-pin {\n  float: right;\n  margin: 4px;\n}\n\n.leftsidebar-minify {\n  position: absolute;\n  right: 4px;\n  bottom: 5px;\n}\n\n.content--wrap {\n  height: 100%;\n}\n\n.floating-toolbar {\n  margin-top: 10px !important;\n}\n\n.app-project-logo {\n  height: 40px;\n  margin: 4px;\n}\n\n.content {\n  height: 100%;\n  padding: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/components/cs-footer/cs-footer.css":
/*!********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/components/cs-footer/cs-footer.css ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "\n/* .list__group__header__append-icon {\n  display:none;\n} */\n.footer-class {\n  z-index: 300 !important;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/components/cs-sidebar/cs-sidebar.css":
/*!**********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/components/cs-sidebar/cs-sidebar.css ***!
  \**********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".leftsidebar-pin {\n  float: right;\n  margin: 4px;\n}\n\n.leftsidebar-minify {\n  position: absolute;\n  right: 4px;\n  bottom: 5px;\n}\n\n.sidebar-active-tile {\n  background-color: red\n}\n\n/* .list__group__header__append-icon {\n  display:none;\n} */\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/components/cs-widget/cs-widget.css":
/*!********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/components/cs-widget/cs-widget.css ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".widget-default {\n  height: 100%;\n  width: 100%;\n}\n\n.widget-buttons-container{\n  position:absolute !important;\n  right: 10px;\n  top: 3px;  \n}\n\n.widget-button{\n  margin:0 !important;\n  width:18px !important;\n  height:18px !important;\n}\n\n.widget-button-icon\n{\n  width:16px !important;\n  height:16px !important;\n}\n\n\n/* Borders */\n\n.widget-border-shadow {\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);\n}\n\n.widget-border-line {\n  border-style: solid;\n  border-width: 1px;\n  border-color: black;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/layout/css-grid/css-grid.css":
/*!**************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/layout/css-grid/css-grid.css ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".css-grid-manager {\n  position: relative;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/layout/flex-grid/flex-grid.css":
/*!****************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/layout/flex-grid/flex-grid.css ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".flex-grid-manager {\n  height: 100%;\n}\n\n.flex-background-widget {\n  position: absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  z-index: 0;\n}\n\n.autowidth {\n  flex: 1; \n}\n\n.flex-widget {\n  height: 100%;\n  width: 100%;\n  /* z-index: 150; */\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/layout/grid/grid.css":
/*!******************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/layout/grid/grid.css ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".grid-manager {\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  position: absolute;  \r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/layout/single/single.css":
/*!**********************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/layout/single/single.css ***!
  \**********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".dashboard-single {\n  margin: 0;\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/layout/split-panel/split-panel.css":
/*!********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/layout/split-panel/split-panel.css ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".split-manager {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;  \n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/widgets/intro/intro-widget.css":
/*!****************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/widgets/intro/intro-widget.css ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".widget-default {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.widget-buttons-container{\r\n  position:absolute !important;\r\n  right: 10px;\r\n  top: 3px;  \r\n}\r\n\r\n.widget-button{\r\n  margin:0 !important;\r\n  width:18px !important;\r\n  height:18px !important;\r\n}\r\n\r\n.widget-button-icon\r\n{\r\n  width:16px !important;\r\n  height:16px !important;\r\n}\r\n\r\n\r\n/* Borders */\r\n\r\n.widget-border-shadow {\r\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.widget-border-line {\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: black;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!./src/widgets/youtube-background/youtube-background-widget.css":
/*!******************************************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader!./src/widgets/youtube-background/youtube-background-widget.css ***!
  \******************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".video-background {\r\n  background: #000;\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -99;\r\n}\r\n\r\n.video-foreground,\r\n.video-background iframe {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/lib/css-base.js":
/*!*******************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader/lib/css-base.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "../../node_modules/css-loader/lib/url/escape.js":
/*!*********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/css-loader/lib/url/escape.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "../../node_modules/deepmerge/dist/es.js":
/*!*************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/deepmerge/dist/es.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),

/***/ "../../node_modules/is-buffer/index.js":
/*!***********************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/is-buffer/index.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../../node_modules/lodash.debounce/index.js":
/*!*****************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/lodash.debounce/index.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/node-libs-browser/node_modules/process/browser.js":
/*!******************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/node-libs-browser/node_modules/process/browser.js ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/reflect-metadata/Reflect.js":
/*!********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/reflect-metadata/Reflect.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));
//# sourceMappingURL=Reflect.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/process/browser.js */ "../../node_modules/node-libs-browser/node_modules/process/browser.js"), __webpack_require__(/*! ./../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/style-loader/lib/addStyles.js":
/*!**********************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/style-loader/lib/addStyles.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "../../node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "../../node_modules/style-loader/lib/urls.js":
/*!*****************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/style-loader/lib/urls.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "../../node_modules/vue-class-component/dist/vue-class-component.common.js":
/*!***********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/vue-class-component/dist/vue-class-component.common.js ***!
  \***********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
  * vue-class-component v6.2.0
  * (c) 2015-present Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(/*! vue */ "vue"));

var hasProto = { __proto__: [] } instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== "object" && type !== "function");
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { return vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (true) {
        if (!(Component.prototype instanceof Vue) && Object.keys(plainData).length > 0) {
            warn('Component class must inherit Vue or its descendant class ' +
                'when class property is used.');
        }
    }
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured' // 2.5
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (typeof descriptor.value === 'function') {
            // methods
            (options.methods || (options.methods = {}))[key] = descriptor.value;
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // `prototype` should not be overwritten
        if (key === 'prototype') {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value)
                && superDescriptor
                && superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if ("development" !== 'production'
            && reservedPropertyNames.indexOf(key) >= 0) {
            warn("Static property name '" + key + "' declared on class '" + Original.name + "' " +
                'conflicts with reserved property name of Vue internal. ' +
                'It may cause unexpected behavior of the component. Consider renaming the property.');
        }
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
(function (Component) {
    function registerHooks(keys) {
        $internalHooks.push.apply($internalHooks, keys);
    }
    Component.registerHooks = registerHooks;
})(Component || (Component = {}));
var Component$1 = Component;

exports.default = Component$1;
exports.createDecorator = createDecorator;
exports.mixins = mixins;


/***/ }),

/***/ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js":
/*!*********************************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/vue-property-decorator/lib/vue-property-decorator.js ***!
  \*********************************************************************************************************/
/*! exports provided: Component, Vue, Mixins, Inject, Provide, Model, Prop, Watch, Emit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Inject", function() { return Inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provide", function() { return Provide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return Model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Prop", function() { return Prop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Watch", function() { return Watch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Emit", function() { return Emit; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Vue", function() { return vue__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a; });
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mixins", function() { return vue_class_component__WEBPACK_IMPORTED_MODULE_1__["mixins"]; });

/** vue-property-decorator verson 7.0.0 MIT LICENSE copyright 2018 kaorun343 */




/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
        (componentOptions.props || (componentOptions.props = {}))[k] = options;
        componentOptions.model = { prop: k, event: event || k };
    });
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
        (componentOptions.props || (componentOptions.props = {}))[k] = options;
    });
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        componentOptions.watch[path] = { handler: handler, deep: deep, immediate: immediate };
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (original.apply(this, args) !== false)
                this.$emit.apply(this, [event || key].concat(args));
        };
    };
}


/***/ }),

/***/ "../../node_modules/vue-resize-directive/dist/Vueresize.js":
/*!*******************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/vue-resize-directive/dist/Vueresize.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t(__webpack_require__(/*! css-element-queries/src/ResizeSensor.js */ "../../node_modules/css-element-queries/src/ResizeSensor.js"),__webpack_require__(/*! lodash.debounce */ "../../node_modules/lodash.debounce/index.js")):undefined}(this,function(n,t){return function(n){function t(r){if(e[r])return e[r].exports;var o=e[r]={exports:{},id:r,loaded:!1};return n[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var e={};return t.m=n,t.c=e,t.p="/",t(0)}([function(n,t,e){var r,o,u;!function(i,c){o=[n,t,e(9),e(36),e(37)],r=c,u="function"==typeof r?r.apply(t,o):r,!(void 0!==u&&(n.exports=u))}(this,function(n,t,e,r,o){"use strict";function u(n){return n&&n.__esModule?n:{default:n}}function i(n){if(!n)return{delay:v,initial:!1};var t=n.initial,e=void 0!==t&&t,r=(0,a.default)(n).map(function(n){return parseInt(n)}).find(function(n){return!isNaN(n)});return r=r||v,{delay:r,initial:e}}function c(n){var t=n.style.display;if(t)return t;var e=n.currentStyle?n.currentStyle:getComputedStyle(n,null);return e.display}function f(n,t){var e=t.value,r=t.arg,o=t.modifiers;if(!n.resizeSensor&&"none"!==c(n)){var u=function(){return e(n)},f=i(o);switch(r){case"debounce":u=d(function(){return e(n)},f.delay);break;case"throttle":u=d(function(){return e(n)},f.delay,{leading:!0,trailing:!0,maxWait:f.delay})}var a=new s.default(n,u);return f.initial&&e(n),a}}Object.defineProperty(t,"__esModule",{value:!0});var a=u(e),s=u(r),l=u(o),p=l.default.debounce,d=void 0===p?l.default:p,v=150;t.default={inserted:function(n,t){var e=t.value,r=t.arg,o=t.modifiers;return e&&"function"==typeof e?void f(n,{value:e,arg:r,modifiers:o}):void console.warn("v-resize should received a function as value")},componentUpdated:function(n,t){var e=t.value,r=t.arg,o=t.modifiers;f(n,{value:e,arg:r,modifiers:o})},unbind:function(n){n.resizeSensor&&s.default.detach(n)}},n.exports=t.default})},function(n,t){var e=n.exports={version:"2.4.0"};"number"==typeof __e&&(__e=e)},function(n,t,e){n.exports=!e(3)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(n,t){n.exports=function(n){try{return!!n()}catch(n){return!0}}},function(n,t){var e=n.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},function(n,t){n.exports=function(n){return"object"==typeof n?null!==n:"function"==typeof n}},function(n,t){n.exports=function(n){if(void 0==n)throw TypeError("Can't call method on  "+n);return n}},function(n,t){var e=Math.ceil,r=Math.floor;n.exports=function(n){return isNaN(n=+n)?0:(n>0?r:e)(n)}},function(n,t,e){var r=e(22),o=e(6);n.exports=function(n){return r(o(n))}},function(n,t,e){n.exports={default:e(10),__esModule:!0}},function(n,t,e){e(35),n.exports=e(1).Object.keys},function(n,t){n.exports=function(n){if("function"!=typeof n)throw TypeError(n+" is not a function!");return n}},function(n,t,e){var r=e(5);n.exports=function(n){if(!r(n))throw TypeError(n+" is not an object!");return n}},function(n,t,e){var r=e(8),o=e(31),u=e(30);n.exports=function(n){return function(t,e,i){var c,f=r(t),a=o(f.length),s=u(i,a);if(n&&e!=e){for(;a>s;)if(c=f[s++],c!=c)return!0}else for(;a>s;s++)if((n||s in f)&&f[s]===e)return n||s||0;return!n&&-1}}},function(n,t){var e={}.toString;n.exports=function(n){return e.call(n).slice(8,-1)}},function(n,t,e){var r=e(11);n.exports=function(n,t,e){if(r(n),void 0===t)return n;switch(e){case 1:return function(e){return n.call(t,e)};case 2:return function(e,r){return n.call(t,e,r)};case 3:return function(e,r,o){return n.call(t,e,r,o)}}return function(){return n.apply(t,arguments)}}},function(n,t,e){var r=e(5),o=e(4).document,u=r(o)&&r(o.createElement);n.exports=function(n){return u?o.createElement(n):{}}},function(n,t){n.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(n,t,e){var r=e(4),o=e(1),u=e(15),i=e(20),c="prototype",f=function(n,t,e){var a,s,l,p=n&f.F,d=n&f.G,v=n&f.S,y=n&f.P,x=n&f.B,h=n&f.W,b=d?o:o[t]||(o[t]={}),m=b[c],g=d?r:v?r[t]:(r[t]||{})[c];d&&(e=t);for(a in e)s=!p&&g&&void 0!==g[a],s&&a in b||(l=s?g[a]:e[a],b[a]=d&&"function"!=typeof g[a]?e[a]:x&&s?u(l,r):h&&g[a]==l?function(n){var t=function(t,e,r){if(this instanceof n){switch(arguments.length){case 0:return new n;case 1:return new n(t);case 2:return new n(t,e)}return new n(t,e,r)}return n.apply(this,arguments)};return t[c]=n[c],t}(l):y&&"function"==typeof l?u(Function.call,l):l,y&&((b.virtual||(b.virtual={}))[a]=l,n&f.R&&m&&!m[a]&&i(m,a,l)))};f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,n.exports=f},function(n,t){var e={}.hasOwnProperty;n.exports=function(n,t){return e.call(n,t)}},function(n,t,e){var r=e(23),o=e(27);n.exports=e(2)?function(n,t,e){return r.f(n,t,o(1,e))}:function(n,t,e){return n[t]=e,n}},function(n,t,e){n.exports=!e(2)&&!e(3)(function(){return 7!=Object.defineProperty(e(16)("div"),"a",{get:function(){return 7}}).a})},function(n,t,e){var r=e(14);n.exports=Object("z").propertyIsEnumerable(0)?Object:function(n){return"String"==r(n)?n.split(""):Object(n)}},function(n,t,e){var r=e(12),o=e(21),u=e(33),i=Object.defineProperty;t.f=e(2)?Object.defineProperty:function(n,t,e){if(r(n),t=u(t,!0),r(e),o)try{return i(n,t,e)}catch(n){}if("get"in e||"set"in e)throw TypeError("Accessors not supported!");return"value"in e&&(n[t]=e.value),n}},function(n,t,e){var r=e(19),o=e(8),u=e(13)(!1),i=e(28)("IE_PROTO");n.exports=function(n,t){var e,c=o(n),f=0,a=[];for(e in c)e!=i&&r(c,e)&&a.push(e);for(;t.length>f;)r(c,e=t[f++])&&(~u(a,e)||a.push(e));return a}},function(n,t,e){var r=e(24),o=e(17);n.exports=Object.keys||function(n){return r(n,o)}},function(n,t,e){var r=e(18),o=e(1),u=e(3);n.exports=function(n,t){var e=(o.Object||{})[n]||Object[n],i={};i[n]=t(e),r(r.S+r.F*u(function(){e(1)}),"Object",i)}},function(n,t){n.exports=function(n,t){return{enumerable:!(1&n),configurable:!(2&n),writable:!(4&n),value:t}}},function(n,t,e){var r=e(29)("keys"),o=e(34);n.exports=function(n){return r[n]||(r[n]=o(n))}},function(n,t,e){var r=e(4),o="__core-js_shared__",u=r[o]||(r[o]={});n.exports=function(n){return u[n]||(u[n]={})}},function(n,t,e){var r=e(7),o=Math.max,u=Math.min;n.exports=function(n,t){return n=r(n),n<0?o(n+t,0):u(n,t)}},function(n,t,e){var r=e(7),o=Math.min;n.exports=function(n){return n>0?o(r(n),9007199254740991):0}},function(n,t,e){var r=e(6);n.exports=function(n){return Object(r(n))}},function(n,t,e){var r=e(5);n.exports=function(n,t){if(!r(n))return n;var e,o;if(t&&"function"==typeof(e=n.toString)&&!r(o=e.call(n)))return o;if("function"==typeof(e=n.valueOf)&&!r(o=e.call(n)))return o;if(!t&&"function"==typeof(e=n.toString)&&!r(o=e.call(n)))return o;throw TypeError("Can't convert object to primitive value")}},function(n,t){var e=0,r=Math.random();n.exports=function(n){return"Symbol(".concat(void 0===n?"":n,")_",(++e+r).toString(36))}},function(n,t,e){var r=e(32),o=e(25);e(26)("keys",function(){return function(n){return o(r(n))}})},function(t,e){t.exports=n},function(n,e){n.exports=t}])});
//# sourceMappingURL=Vueresize.js.map

/***/ }),

/***/ "../../node_modules/vue-router/dist/vue-router.esm.js":
/*!**************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/vue-router/dist/vue-router.esm.js ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("development" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "development" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (true) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("development" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (true) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "development" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "development" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),

/***/ "../../node_modules/vue-split-panel/dist/vue-split-panel.js":
/*!********************************************************************************************!*\
  !*** C:/arnoud/Projects/csVue/csnext/node_modules/vue-split-panel/dist/vue-split-panel.js ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(1)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(28)
  , hide      = __webpack_require__(32)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(37)
  , enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(8)
  , defined = __webpack_require__(6);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(6);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _split = __webpack_require__(53);

var _split2 = _interopRequireDefault(_split);

var _splitArea = __webpack_require__(52);

var _splitArea2 = _interopRequireDefault(_splitArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_split2.default.SplitArea = _splitArea2.default;
exports.default = _split2.default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(22), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(23), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emitter = __webpack_require__(5);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SplitArea',
    mixins: [_emitter2.default],
    props: {
        size: {
            type: Number,
            default: 50
        },
        minSize: {
            type: Number,
            default: 100
        }
    },
    computed: {
        classes: function classes() {
            return 'split split-' + this.$parent.direction;
        }
    },
    watch: {
        'size': function size(val) {
            this.$parent.changeAreaSize();
        },
        'minSize': function minSize(val) {
            this.$parent.changeAreaSize();
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emitter = __webpack_require__(5);

var _emitter2 = _interopRequireDefault(_emitter);

var _split = __webpack_require__(51);

var _split2 = _interopRequireDefault(_split);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Split',
    mixins: [_emitter2.default],
    props: {
        direction: {
            type: String,
            default: 'horizontal'
        },
        gutterSize: {
            type: Number,
            default: 8
        }
    },
    data: function data() {
        return {
            elements: [],
            sizes: [],
            minSizes: [],
            instance: null
        };
    },

    methods: {
        init: function init() {
            var self = this;
            if (self.instance !== null) {
                self.instance.destroy();
            }
            self.instance = null;
            self.instance = (0, _split2.default)(self.elements, {
                direction: self.direction,
                sizes: self.sizes,
                minSize: self.minSizes,
                gutterSize: self.gutterSize,
                cursor: self.direction === 'horizontal' ? 'col-resize' : 'row-resize',
                onDrag: function onDrag() {
                    self.$emit('onDrag', self.instance.getSizes());
                },
                onDragStart: function onDragStart() {
                    self.$emit('onDragStart', self.instance.getSizes());
                },
                onDragEnd: function onDragEnd(str) {
                    self.$emit('onDragEnd', self.instance.getSizes());
                }
            });
        },
        changeAreaSize: function changeAreaSize() {
            var self = this;
            self.sizes = [];
            self.minSizes = [];
            self.$slots.default.forEach(function (vnode) {
                if (vnode.tag && vnode.tag.indexOf('SplitArea') > -1) {
                    self.sizes.push(vnode.componentInstance.size);
                    self.minSizes.push(vnode.componentInstance.minSize);
                }
            });
            self.init();
        },
        reset: function reset() {
            this.init();
        },
        getSizes: function getSizes() {
            return this.instance.getSizes();
        }
    },
    mounted: function mounted() {
        var self = this;
        self.elements = [];
        self.sizes = [];
        self.minSizes = [];
        self.$slots.default.forEach(function (vnode) {
            if (vnode.tag && vnode.tag.indexOf('SplitArea') > -1) {
                self.elements.push(vnode.elm);
                self.sizes.push(vnode.componentInstance.size);
                self.minSizes.push(vnode.componentInstance.minSize);
            }
        });
        self.init();
    },

    watch: {
        'direction': function direction(val) {
            this.init();
        },
        'gutterSize': function gutterSize(val) {
            this.init();
        }
    }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
    return _c('div', {
      class: _vm.classes
    }, [_vm._t("default")], 2);
  }, staticRenderFns: [] };

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "split"
    }, [_vm._t("default")], 2);
  }, staticRenderFns: [] };

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _split = __webpack_require__(14);

var _split2 = _interopRequireDefault(_split);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueSplit = {
  Split: _split2.default,
  SplitArea: _split2.default.SplitArea
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  (0, _keys2.default)(VueSplit).forEach(function (key) {
    Vue.component(key, VueSplit[key]);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

module.exports = (0, _assign2.default)(VueSplit, { install: install });

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
module.exports = __webpack_require__(0).Object.assign;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
module.exports = __webpack_require__(0).Object.keys;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(11)
  , toLength  = __webpack_require__(44)
  , toIndex   = __webpack_require__(43);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(24);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(35)
  , createDesc = __webpack_require__(40);
module.exports = __webpack_require__(2) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(2) && !__webpack_require__(1)(function(){
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(9)
  , gOPS     = __webpack_require__(36)
  , pIE      = __webpack_require__(38)
  , toObject = __webpack_require__(12)
  , IObject  = __webpack_require__(8)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(1)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(25)
  , IE8_DOM_DEFINE = __webpack_require__(33)
  , toPrimitive    = __webpack_require__(45)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(31)
  , toIObject    = __webpack_require__(11)
  , arrayIndexOf = __webpack_require__(26)(false)
  , IE_PROTO     = __webpack_require__(41)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(7)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(1);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(42)('keys')
  , uid    = __webpack_require__(46);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(10)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(10)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(7);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(34)});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(12)
  , $keys    = __webpack_require__(9);

__webpack_require__(39)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(50)();
// imports


// module
exports.push([module.i, "\n.split {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n  width: 100%;\n}\n.gutter {\n  background-color: #eee;\n  background-repeat: no-repeat;\n  background-position: 50%;\n}\n.gutter.gutter-horizontal {\n  cursor: col-resize;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n}\n.gutter.gutter-vertical {\n  cursor: row-resize;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');\n}\n.split.split-horizontal, .gutter.gutter-horizontal {\n  height: 100%;\n  float: left;\n}\n", ""]);

// exports


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/*! Split.js - v1.3.5 */

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

// The programming goals of Split.js are to deliver readable, understandable and
// maintainable code, while at the same time manually optimizing for tiny minified file size,
// browser compatibility without additional requirements, graceful fallback (IE8 is supported)
// and very few assumptions about the user's page layout.
var global = window;
var document = global.document;

// Save a couple long function names that are used frequently.
// This optimization saves around 400 bytes.
var addEventListener = 'addEventListener';
var removeEventListener = 'removeEventListener';
var getBoundingClientRect = 'getBoundingClientRect';
var NOOP = function () { return false; };

// Figure out if we're in IE8 or not. IE8 will still render correctly,
// but will be static instead of draggable.
var isIE8 = global.attachEvent && !global[addEventListener];

// This library only needs two helper functions:
//
// The first determines which prefixes of CSS calc we need.
// We only need to do this once on startup, when this anonymous function is called.
//
// Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
// http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
var calc = (['', '-webkit-', '-moz-', '-o-'].filter(function (prefix) {
    var el = document.createElement('div');
    el.style.cssText = "width:" + prefix + "calc(9px)";

    return (!!el.style.length)
}).shift()) + "calc";

// The second helper function allows elements and string selectors to be used
// interchangeably. In either case an element is returned. This allows us to
// do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
var elementOrSelector = function (el) {
    if (typeof el === 'string' || el instanceof String) {
        return document.querySelector(el)
    }

    return el
};

// The main function to initialize a split. Split.js thinks about each pair
// of elements as an independant pair. Dragging the gutter between two elements
// only changes the dimensions of elements in that pair. This is key to understanding
// how the following functions operate, since each function is bound to a pair.
//
// A pair object is shaped like this:
//
// {
//     a: DOM element,
//     b: DOM element,
//     aMin: Number,
//     bMin: Number,
//     dragging: Boolean,
//     parent: DOM element,
//     isFirst: Boolean,
//     isLast: Boolean,
//     direction: 'horizontal' | 'vertical'
// }
//
// The basic sequence:
//
// 1. Set defaults to something sane. `options` doesn't have to be passed at all.
// 2. Initialize a bunch of strings based on the direction we're splitting.
//    A lot of the behavior in the rest of the library is paramatized down to
//    rely on CSS strings and classes.
// 3. Define the dragging helper functions, and a few helpers to go with them.
// 4. Loop through the elements while pairing them off. Every pair gets an
//    `pair` object, a gutter, and special isFirst/isLast properties.
// 5. Actually size the pair elements, insert gutters and attach event listeners.
var Split = function (ids, options) {
    if ( options === void 0 ) options = {};

    var dimension;
    var clientDimension;
    var clientAxis;
    var position;
    var paddingA;
    var paddingB;
    var elements;

    // All DOM elements in the split should have a common parent. We can grab
    // the first elements parent and hope users read the docs because the
    // behavior will be whacky otherwise.
    var parent = elementOrSelector(ids[0]).parentNode;
    var parentFlexDirection = global.getComputedStyle(parent).flexDirection;

    // Set default options.sizes to equal percentages of the parent element.
    var sizes = options.sizes || ids.map(function () { return 100 / ids.length; });

    // Standardize minSize to an array if it isn't already. This allows minSize
    // to be passed as a number.
    var minSize = options.minSize !== undefined ? options.minSize : 100;
    var minSizes = Array.isArray(minSize) ? minSize : ids.map(function () { return minSize; });
    var gutterSize = options.gutterSize !== undefined ? options.gutterSize : 10;
    var snapOffset = options.snapOffset !== undefined ? options.snapOffset : 30;
    var direction = options.direction || 'horizontal';
    var cursor = options.cursor || (direction === 'horizontal' ? 'ew-resize' : 'ns-resize');
    var gutter = options.gutter || (function (i, gutterDirection) {
        var gut = document.createElement('div');
        gut.className = "gutter gutter-" + gutterDirection;
        return gut
    });
    var elementStyle = options.elementStyle || (function (dim, size, gutSize) {
        var style = {};

        if (typeof size !== 'string' && !(size instanceof String)) {
            if (!isIE8) {
                style[dim] = calc + "(" + size + "% - " + gutSize + "px)";
            } else {
                style[dim] = size + "%";
            }
        } else {
            style[dim] = size;
        }

        return style
    });
    var gutterStyle = options.gutterStyle || (function (dim, gutSize) { return (( obj = {}, obj[dim] = (gutSize + "px"), obj ))
        var obj; });

    // 2. Initialize a bunch of strings based on the direction we're splitting.
    // A lot of the behavior in the rest of the library is paramatized down to
    // rely on CSS strings and classes.
    if (direction === 'horizontal') {
        dimension = 'width';
        clientDimension = 'clientWidth';
        clientAxis = 'clientX';
        position = 'left';
        paddingA = 'paddingLeft';
        paddingB = 'paddingRight';
    } else if (direction === 'vertical') {
        dimension = 'height';
        clientDimension = 'clientHeight';
        clientAxis = 'clientY';
        position = 'top';
        paddingA = 'paddingTop';
        paddingB = 'paddingBottom';
    }

    // 3. Define the dragging helper functions, and a few helpers to go with them.
    // Each helper is bound to a pair object that contains it's metadata. This
    // also makes it easy to store references to listeners that that will be
    // added and removed.
    //
    // Even though there are no other functions contained in them, aliasing
    // this to self saves 50 bytes or so since it's used so frequently.
    //
    // The pair object saves metadata like dragging state, position and
    // event listener references.

    function setElementSize (el, size, gutSize) {
        // Split.js allows setting sizes via numbers (ideally), or if you must,
        // by string, like '300px'. This is less than ideal, because it breaks
        // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
        // make sure you calculate the gutter size by hand.
        var style = elementStyle(dimension, size, gutSize);

        // eslint-disable-next-line no-param-reassign
        Object.keys(style).forEach(function (prop) { return (el.style[prop] = style[prop]); });
    }

    function setGutterSize (gutterElement, gutSize) {
        var style = gutterStyle(dimension, gutSize);

        // eslint-disable-next-line no-param-reassign
        Object.keys(style).forEach(function (prop) { return (gutterElement.style[prop] = style[prop]); });
    }

    // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
    // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
    // which allows the viewport to be resized without additional logic.
    // Element a's size is the same as offset. b's size is total size - a size.
    // Both sizes are calculated from the initial parent percentage,
    // then the gutter size is subtracted.
    function adjust (offset) {
        var a = elements[this.a];
        var b = elements[this.b];
        var percentage = a.size + b.size;

        a.size = (offset / this.size) * percentage;
        b.size = (percentage - ((offset / this.size) * percentage));

        setElementSize(a.element, a.size, this.aGutterSize);
        setElementSize(b.element, b.size, this.bGutterSize);
    }

    // drag, where all the magic happens. The logic is really quite simple:
    //
    // 1. Ignore if the pair is not dragging.
    // 2. Get the offset of the event.
    // 3. Snap offset to min if within snappable range (within min + snapOffset).
    // 4. Actually adjust each element in the pair to offset.
    //
    // ---------------------------------------------------------------------
    // |    | <- a.minSize               ||              b.minSize -> |    |
    // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
    // |    |  |                         ||                        |  |    |
    // |    |  |                         ||                        |  |    |
    // ---------------------------------------------------------------------
    // | <- this.start                                        this.size -> |
    function drag (e) {
        var offset;

        if (!this.dragging) { return }

        // Get the offset of the event from the first side of the
        // pair `this.start`. Supports touch events, but not multitouch, so only the first
        // finger `touches[0]` is counted.
        if ('touches' in e) {
            offset = e.touches[0][clientAxis] - this.start;
        } else {
            offset = e[clientAxis] - this.start;
        }

        // If within snapOffset of min or max, set offset to min or max.
        // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
        // Include the appropriate gutter sizes to prevent overflows.
        if (offset <= elements[this.a].minSize + snapOffset + this.aGutterSize) {
            offset = elements[this.a].minSize + this.aGutterSize;
        } else if (offset >= this.size - (elements[this.b].minSize + snapOffset + this.bGutterSize)) {
            offset = this.size - (elements[this.b].minSize + this.bGutterSize);
        }

        // Actually adjust the size.
        adjust.call(this, offset);

        // Call the drag callback continously. Don't do anything too intensive
        // in this callback.
        if (options.onDrag) {
            options.onDrag();
        }
    }

    // Cache some important sizes when drag starts, so we don't have to do that
    // continously:
    //
    // `size`: The total size of the pair. First + second + first gutter + second gutter.
    // `start`: The leading side of the first element.
    //
    // ------------------------------------------------
    // |      aGutterSize -> |||                      |
    // |                     |||                      |
    // |                     |||                      |
    // |                     ||| <- bGutterSize       |
    // ------------------------------------------------
    // | <- start                             size -> |
    function calculateSizes () {
        // Figure out the parent size minus padding.
        var a = elements[this.a].element;
        var b = elements[this.b].element;

        this.size = a[getBoundingClientRect]()[dimension] + b[getBoundingClientRect]()[dimension] + this.aGutterSize + this.bGutterSize;
        this.start = a[getBoundingClientRect]()[position];
    }

    // stopDragging is very similar to startDragging in reverse.
    function stopDragging () {
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;

        if (self.dragging && options.onDragEnd) {
            options.onDragEnd();
        }

        self.dragging = false;

        // Remove the stored event listeners. This is why we store them.
        global[removeEventListener]('mouseup', self.stop);
        global[removeEventListener]('touchend', self.stop);
        global[removeEventListener]('touchcancel', self.stop);

        self.parent[removeEventListener]('mousemove', self.move);
        self.parent[removeEventListener]('touchmove', self.move);

        // Delete them once they are removed. I think this makes a difference
        // in memory usage with a lot of splits on one page. But I don't know for sure.
        delete self.stop;
        delete self.move;

        a[removeEventListener]('selectstart', NOOP);
        a[removeEventListener]('dragstart', NOOP);
        b[removeEventListener]('selectstart', NOOP);
        b[removeEventListener]('dragstart', NOOP);

        a.style.userSelect = '';
        a.style.webkitUserSelect = '';
        a.style.MozUserSelect = '';
        a.style.pointerEvents = '';

        b.style.userSelect = '';
        b.style.webkitUserSelect = '';
        b.style.MozUserSelect = '';
        b.style.pointerEvents = '';

        self.gutter.style.cursor = '';
        self.parent.style.cursor = '';
    }

    // startDragging calls `calculateSizes` to store the inital size in the pair object.
    // It also adds event listeners for mouse/touch events,
    // and prevents selection while dragging so avoid the selecting text.
    function startDragging (e) {
        // Alias frequently used variables to save space. 200 bytes.
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;

        // Call the onDragStart callback.
        if (!self.dragging && options.onDragStart) {
            options.onDragStart();
        }

        // Don't actually drag the element. We emulate that in the drag function.
        e.preventDefault();

        // Set the dragging property of the pair object.
        self.dragging = true;

        // Create two event listeners bound to the same pair object and store
        // them in the pair object.
        self.move = drag.bind(self);
        self.stop = stopDragging.bind(self);

        // All the binding. `window` gets the stop events in case we drag out of the elements.
        global[addEventListener]('mouseup', self.stop);
        global[addEventListener]('touchend', self.stop);
        global[addEventListener]('touchcancel', self.stop);

        self.parent[addEventListener]('mousemove', self.move);
        self.parent[addEventListener]('touchmove', self.move);

        // Disable selection. Disable!
        a[addEventListener]('selectstart', NOOP);
        a[addEventListener]('dragstart', NOOP);
        b[addEventListener]('selectstart', NOOP);
        b[addEventListener]('dragstart', NOOP);

        a.style.userSelect = 'none';
        a.style.webkitUserSelect = 'none';
        a.style.MozUserSelect = 'none';
        a.style.pointerEvents = 'none';

        b.style.userSelect = 'none';
        b.style.webkitUserSelect = 'none';
        b.style.MozUserSelect = 'none';
        b.style.pointerEvents = 'none';

        // Set the cursor, both on the gutter and the parent element.
        // Doing only a, b and gutter causes flickering.
        self.gutter.style.cursor = cursor;
        self.parent.style.cursor = cursor;

        // Cache the initial sizes of the pair.
        calculateSizes.call(self);
    }

    // 5. Create pair and element objects. Each pair has an index reference to
    // elements `a` and `b` of the pair (first and second elements).
    // Loop through the elements while pairing them off. Every pair gets a
    // `pair` object, a gutter, and isFirst/isLast properties.
    //
    // Basic logic:
    //
    // - Starting with the second element `i > 0`, create `pair` objects with
    //   `a = i - 1` and `b = i`
    // - Set gutter sizes based on the _pair_ being first/last. The first and last
    //   pair have gutterSize / 2, since they only have one half gutter, and not two.
    // - Create gutter elements and add event listeners.
    // - Set the size of the elements, minus the gutter sizes.
    //
    // -----------------------------------------------------------------------
    // |     i=0     |         i=1         |        i=2       |      i=3     |
    // |             |       isFirst       |                  |     isLast   |
    // |           pair 0                pair 1             pair 2           |
    // |             |                     |                  |              |
    // -----------------------------------------------------------------------
    var pairs = [];
    elements = ids.map(function (id, i) {
        // Create the element object.
        var element = {
            element: elementOrSelector(id),
            size: sizes[i],
            minSize: minSizes[i],
        };

        var pair;

        if (i > 0) {
            // Create the pair object with it's metadata.
            pair = {
                a: i - 1,
                b: i,
                dragging: false,
                isFirst: (i === 1),
                isLast: (i === ids.length - 1),
                direction: direction,
                parent: parent,
            };

            // For first and last pairs, first and last gutter width is half.
            pair.aGutterSize = gutterSize;
            pair.bGutterSize = gutterSize;

            if (pair.isFirst) {
                pair.aGutterSize = gutterSize / 2;
            }

            if (pair.isLast) {
                pair.bGutterSize = gutterSize / 2;
            }

            // if the parent has a reverse flex-direction, switch the pair elements.
            if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
                var temp = pair.a;
                pair.a = pair.b;
                pair.b = temp;
            }
        }

        // Determine the size of the current element. IE8 is supported by
        // staticly assigning sizes without draggable gutters. Assigns a string
        // to `size`.
        //
        // IE9 and above
        if (!isIE8) {
            // Create gutter elements for each pair.
            if (i > 0) {
                var gutterElement = gutter(i, direction);
                setGutterSize(gutterElement, gutterSize);

                gutterElement[addEventListener]('mousedown', startDragging.bind(pair));
                gutterElement[addEventListener]('touchstart', startDragging.bind(pair));

                parent.insertBefore(gutterElement, element.element);

                pair.gutter = gutterElement;
            }
        }

        // Set the element size to our determined size.
        // Half-size gutters for first and last elements.
        if (i === 0 || i === ids.length - 1) {
            setElementSize(element.element, element.size, gutterSize / 2);
        } else {
            setElementSize(element.element, element.size, gutterSize);
        }

        var computedSize = element.element[getBoundingClientRect]()[dimension];

        if (computedSize < element.minSize) {
            element.minSize = computedSize;
        }

        // After the first iteration, and we have a pair object, append it to the
        // list of pairs.
        if (i > 0) {
            pairs.push(pair);
        }

        return element
    });

    function setSizes (newSizes) {
        newSizes.forEach(function (newSize, i) {
            if (i > 0) {
                var pair = pairs[i - 1];
                var a = elements[pair.a];
                var b = elements[pair.b];

                a.size = newSizes[i - 1];
                b.size = newSize;

                setElementSize(a.element, a.size, pair.aGutterSize);
                setElementSize(b.element, b.size, pair.bGutterSize);
            }
        });
    }

    function destroy () {
        pairs.forEach(function (pair) {
            pair.parent.removeChild(pair.gutter);
            elements[pair.a].element.style[dimension] = '';
            elements[pair.b].element.style[dimension] = '';
        });
    }

    if (isIE8) {
        return {
            setSizes: setSizes,
            destroy: destroy,
        }
    }

    return {
        setSizes: setSizes,
        getSizes: function getSizes () {
            return elements.map(function (element) { return element.size; })
        },
        collapse: function collapse (i) {
            if (i === pairs.length) {
                var pair = pairs[i - 1];

                calculateSizes.call(pair);

                if (!isIE8) {
                    adjust.call(pair, pair.size - pair.bGutterSize);
                }
            } else {
                var pair$1 = pairs[i];

                calculateSizes.call(pair$1);

                if (!isIE8) {
                    adjust.call(pair$1, pair$1.aGutterSize);
                }
            }
        },
        destroy: destroy,
    }
};

return Split;

})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(55)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if (media) {
		styleElement.setAttribute("media", media);
	}

	if (sourceMap) {
		// https://developer.chrome.com/devtools/docs/javascript-debugging
		// this makes source maps inside style tags work properly in Chrome
		css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(54)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ })
/******/ ]);
});

/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "../cs-core/dist/classes/app-theme.js":
/*!********************************************!*\
  !*** ../cs-core/dist/classes/app-theme.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Application look and feel
class AppTheme {
    constructor() {
        this.colors = {};
    }
}
exports.AppTheme = AppTheme;
//# sourceMappingURL=app-theme.js.map

/***/ }),

/***/ "../cs-core/dist/classes/dashboard-options.js":
/*!****************************************************!*\
  !*** ../cs-core/dist/classes/dashboard-options.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class BaseDashboardOptions {
    get Background() {
        return this.background;
    }
    get EditButton() {
        return this.editButton;
    }
    set EditButton(value) {
        this.editButton = value;
    }
    get TouchGesturesEnabled() {
        return this.touchGesturesEnabled;
    }
    set TouchGesturesEnabled(value) {
        this.touchGesturesEnabled = value;
    }
}
exports.BaseDashboardOptions = BaseDashboardOptions;
//# sourceMappingURL=dashboard-options.js.map

/***/ }),

/***/ "../cs-core/dist/classes/datasource.js":
/*!*********************************************!*\
  !*** ../cs-core/dist/classes/datasource.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProcessorActions;
(function (ProcessorActions) {
    ProcessorActions[ProcessorActions["Create"] = 0] = "Create";
    ProcessorActions[ProcessorActions["Read"] = 1] = "Read";
    ProcessorActions[ProcessorActions["Update"] = 2] = "Update";
    ProcessorActions[ProcessorActions["Delete"] = 3] = "Delete";
})(ProcessorActions = exports.ProcessorActions || (exports.ProcessorActions = {}));
class DatasourceProcessorBase {
    execute(sources, datasource, action) {
        return Promise.resolve();
    }
}
exports.DatasourceProcessorBase = DatasourceProcessorBase;
//# sourceMappingURL=datasource.js.map

/***/ }),

/***/ "../cs-core/dist/classes/editor-schema.js":
/*!************************************************!*\
  !*** ../cs-core/dist/classes/editor-schema.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class EditorSchema {
}
exports.EditorSchema = EditorSchema;
//# sourceMappingURL=editor-schema.js.map

/***/ }),

/***/ "../cs-core/dist/classes/form-decorators.js":
/*!**************************************************!*\
  !*** ../cs-core/dist/classes/form-decorators.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// import 'reflect-metadata';
Object.defineProperty(exports, "__esModule", { value: true });
function Form(options) {
    return function decorator(target) {
        // console.log(target);
        if (!target.prototype.hasOwnProperty('_form')) {
            target.prototype._form = options;
        }
        else {
            target.prototype._form = Object.assign({}, target.prototype._form, options);
        }
    };
}
exports.Form = Form;
function FormField(options) {
    return function decorator(object, key, target) {
        // let res = Object.getOwnPropertyDescriptor(object,key);
        options._object = object;
        options._key = key;
        options._target = target;
        options._model = object[key];
        // let meta = Reflect.getMetadata("design:returntype", object, key);
        if (!object.hasOwnProperty('_form')) {
            object._form = { fields: [options] };
        }
        else {
            object._form.fields.push(options);
        }
    };
}
exports.FormField = FormField;
//# sourceMappingURL=form-decorators.js.map

/***/ }),

/***/ "../cs-core/dist/classes/grid-dashboard-options.js":
/*!*********************************************************!*\
  !*** ../cs-core/dist/classes/grid-dashboard-options.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const dashboard_options_1 = __webpack_require__(/*! ./dashboard-options */ "../cs-core/dist/classes/dashboard-options.js");
class GridDashboardOptions extends dashboard_options_1.BaseDashboardOptions {
}
exports.GridDashboardOptions = GridDashboardOptions;
//# sourceMappingURL=grid-dashboard-options.js.map

/***/ }),

/***/ "../cs-core/dist/classes/navigation-options.js":
/*!*****************************************************!*\
  !*** ../cs-core/dist/classes/navigation-options.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class NavigationOptions {
}
exports.NavigationOptions = NavigationOptions;
//# sourceMappingURL=navigation-options.js.map

/***/ }),

/***/ "../cs-core/dist/classes/page.js":
/*!***************************************!*\
  !*** ../cs-core/dist/classes/page.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class Page {
}
exports.Page = Page;
//# sourceMappingURL=page.js.map

/***/ }),

/***/ "../cs-core/dist/classes/widget-options.js":
/*!*************************************************!*\
  !*** ../cs-core/dist/classes/widget-options.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class WidgetOptions {
}
exports.WidgetOptions = WidgetOptions;
//# sourceMappingURL=widget-options.js.map

/***/ }),

/***/ "../cs-core/dist/classes/widget.js":
/*!*****************************************!*\
  !*** ../cs-core/dist/classes/widget.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["component"] = 0] = "component";
    WidgetType[WidgetType["html"] = 1] = "html";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
//# sourceMappingURL=widget.js.map

/***/ }),

/***/ "../cs-core/dist/index.js":
/*!********************************!*\
  !*** ../cs-core/dist/index.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(/*! ./classes/dashboard-options */ "../cs-core/dist/classes/dashboard-options.js"));
var grid_dashboard_options_1 = __webpack_require__(/*! ./classes/grid-dashboard-options */ "../cs-core/dist/classes/grid-dashboard-options.js");
exports.GridDashboardOptions = grid_dashboard_options_1.GridDashboardOptions;
__export(__webpack_require__(/*! ./classes/page */ "../cs-core/dist/classes/page.js"));
__export(__webpack_require__(/*! ./classes/widget */ "../cs-core/dist/classes/widget.js"));
__export(__webpack_require__(/*! ./classes/datasource */ "../cs-core/dist/classes/datasource.js"));
__export(__webpack_require__(/*! ./classes/app-theme */ "../cs-core/dist/classes/app-theme.js"));
__export(__webpack_require__(/*! ./classes/navigation-options */ "../cs-core/dist/classes/navigation-options.js"));
__export(__webpack_require__(/*! ./classes/editor-schema */ "../cs-core/dist/classes/editor-schema.js"));
__export(__webpack_require__(/*! ./utils/message-bus/message-bus-service */ "../cs-core/dist/utils/message-bus/message-bus-service.js"));
__export(__webpack_require__(/*! ./classes/widget-options */ "../cs-core/dist/classes/widget-options.js"));
__export(__webpack_require__(/*! ./classes/form-decorators */ "../cs-core/dist/classes/form-decorators.js"));
var guid_1 = __webpack_require__(/*! ./utils/guid */ "../cs-core/dist/utils/guid.js");
exports.guidGenerator = guid_1.guidGenerator;
// export *  from './classes/plugin';
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../cs-core/dist/utils/guid.js":
/*!*************************************!*\
  !*** ../cs-core/dist/utils/guid.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function guidGenerator() {
    const S4 = () => {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}
exports.guidGenerator = guidGenerator;
function idGenerator() {
    const S4 = () => {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4());
}
exports.idGenerator = idGenerator;
//# sourceMappingURL=guid.js.map

/***/ }),

/***/ "../cs-core/dist/utils/message-bus/message-bus-handle.js":
/*!***************************************************************!*\
  !*** ../cs-core/dist/utils/message-bus/message-bus-handle.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Interface for message bus callbacks, i.e. (data: any) => any,
// so you can supply a single data argument of any type, and it may return any type.
Object.defineProperty(exports, "__esModule", { value: true });
// Handle returned when subscribing to a topic
class MessageBusHandle {
    constructor(topic, callback) {
        this.topic = topic;
        this.callback = callback;
    }
}
exports.MessageBusHandle = MessageBusHandle;
//# sourceMappingURL=message-bus-handle.js.map

/***/ }),

/***/ "../cs-core/dist/utils/message-bus/message-bus-service.js":
/*!****************************************************************!*\
  !*** ../cs-core/dist/utils/message-bus/message-bus-service.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const message_bus_handle_1 = __webpack_require__(/*! ./message-bus-handle */ "../cs-core/dist/utils/message-bus/message-bus-handle.js");
/**
 * Simple message bus service, used for subscribing and unsubsubscribing to topics.
 * @see {@link https://gist.github.com/floatingmonkey/3384419}
 */
class MessageBusService {
    constructor() {
        this.cache = {};
        this.confirms = [];
    }
    /**
     * Publish to a topic
     */
    publish(topic, title, data) {
        // window.console.log('publish: ' + topic + ', ' + title);
        if (!this.cache[topic]) {
            return;
        }
        this.cache[topic].forEach(cb => cb(title, data));
    }
    /**
     * Subscribe to a topic
     * @param {string} topic The desired topic of the message.
     * @param {IMessageBusCallback} callback The callback to call.
     */
    subscribe(topic, callback) {
        if (!this.cache[topic]) {
            this.cache[topic] = new Array();
        }
        this.cache[topic].push(callback);
        return new message_bus_handle_1.MessageBusHandle(topic, callback);
    }
    /**
     * Unsubscribe to a topic by providing its handle
     */
    unsubscribe(handle) {
        const topic = handle.topic;
        const callback = handle.callback;
        if (!this.cache[topic]) {
            return;
        }
        this.cache[topic].forEach((cb, idx) => {
            if (cb === callback) {
                this.cache[topic].splice(idx, 1);
                return;
            }
        });
    }
}
exports.MessageBusService = MessageBusService;
//# sourceMappingURL=message-bus-service.js.map

/***/ }),

/***/ "./src/assets/fonts/KFOlCnqEu92Fr1MmEU9fBBc4.woff2":
/*!*********************************************************!*\
  !*** ./src/assets/fonts/KFOlCnqEu92Fr1MmEU9fBBc4.woff2 ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;charset=utf-8;base64,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"

/***/ }),

/***/ "./src/assets/fonts/KFOlCnqEu92Fr1MmWUlfBBc4.woff2":
/*!*********************************************************!*\
  !*** ./src/assets/fonts/KFOlCnqEu92Fr1MmWUlfBBc4.woff2 ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;charset=utf-8;base64,d09GMgABAAAAADxMABIAAAAAinwAADvpAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGmQbmXocg0oGYACGTAhICYM8EQwKgdUQgbxlC4NeABKBeAE2AiQDhzYEIAWCfgcgDIIpGzd7FezYS4DzgCDEa36dgunmIu52KJX5sVuNDNRSRZYk+/9LAh1DLLgnqNt7QkuMQyYT98nO2SdMIQQKuURajs0bp97gAh0rNvpy8sXYvUu3+4df46sfrTzy9jD40F2VVp6mqKHMuerEGx2OZcZyKFJO7Kw0M2s7Z2DbyJ/kpD88P7fe/wuiBqNiAxFjwmCMGCD0NqLGcMCoGjWiJHpkClIlAhOjCaMPC6uQaMW+8xQeIju+XldVz+yeoOz/7EiGyqEYjKjMzC5TuGrj269NOhGdPUvs61xCxDYiZqH8lJH5DXrg8afamw/AAxEJgCQYltwld5c/JC0U0tfdOYU6dR4VzYWiddFJnceVVHTn0p1zj+kVqs7X4ABsWamQq0rWNm9OFA95Gr7PMSxJEVl49q1sda3YffOPlWWhjv9PZ/m/ZBn+zFh2wh0glanSaUamXZngeO9Otn8jJSx5iybUpQUsKiTZXqhu9/WZXNtLs1CxSuaIeLcJkkgkjqgtkaLL5pjYcJjAAcmPsXTXdrWt8GdEXqsKoeo/rpU2b/7mgP8du6ZlucKVyYndLGazKfDclWgKxLISUJ6srDzAOgJFqq4aWLKscJL8r6VV9D+pW20V6sz1bAFZwFPq8XAXoCWs+kuaLFWq1DNV6nFGWm/RKrOkDVWWxqjWujMez7Iznl1c8EPUsSP8ADlU4ThQYDiM8I0ABBFQ4P/WUju7AXKn4krgKhyw0XUVavbPXnZuZo92jwK0FyDapHB3r7asWgUogTYlJFWhW+OjfK3si8qrAiFtVVx92S+LB2ksHemFiDdEis7ev+v7vs7nOnQn3WE7E1corhEiRx3z/L9xjC2MWtW7+rYAAek7St/tMOcmL/w1FyCFVPy8yY4AAhN3/u47gwnTdBDElh9IunSQPHkgBQpAeHggpUpBylWCdOsDO2cTBAIDQBQAGBAAIJB0EACEER2EPOiQuTUoXvh8cwbFS2/2T6F41fbdBRQhAQDehQ648uKbCwgC3mxIRgUTrgjbELbWtqnny9dTb3saJd/nVqER/zeLgGFBJBoWh+VDOywiKJJKFOZFRdnFQPyKv+Wo9nZPQh4sVrIblZAvs6Lxy0Ij3qNyK/8vLXSlKNJO01MQrJhSf1okNBGisDRp2WOvfXQQkegjM2CEwoSZg8zR2XPkwo07Bk8s3nz48levQZNm55x3wUWXXDZpyrQZV1x12x133fOPR1565bU35n20YNGSZRs2QYzGNUgU0kzsZkbWI7IgWFuYICLMtki5W9PMgnZERqTZ9ha1dTQFOhzAALN5z5Z4tca7Fb4qqGxdo0GLaYU6n4ULuIhLuIxJ9bi35vAET/EMz9WL1r3EK7zGG3zEAhaxhGW10ppVrGFdbbRicz3Ep5nyUe+BsYjLG4di1DuUFpi0waw3HsEgBcyazQQPnu4DgpBd49kUnx6KKVpmsfKyxuu40rohiZFmSbJi/bxAWEAColi34pH3XoSm3RZjj1ncxwM87F8aGoZIgmdrKdRW0AA6HMDUvKYyBvUwGjSa0KxetOIlXuG1eKMt30wtRFDbQAPocAATlXiBl3iF13jTOpI9aSx6fEiyBwIYzY++vI9sFgwWsYTlAVEwFZJCI1rQqgViAxvYiAAP8HBALGotaKDDIWDExTR7H0qeDxGVs3mh8RKv8Bpv1Me4FrCIJSxbKHhPBI3Gsfq0yu/d3mItseybThLA7NuSgjWQvMJ6ccLNq9sg3n2Fjb0cePYcK2pl7zSmMZn9I68uvGaUNu1Ij5W00yWVoOaX2BMDH8dBAsdfOMrk3RZ+evexBWP7mtt6sWikJ2dVa62mec0RIdv1oG/9x4CzfaokjjsLU+LxorLik/z728v4M8xQzHfntiy+398s0z7Nf1VLgB+Tf7u2+KdQ33cSK7votvN/rfm/9GqmbBZzn7b04pGZXdzOUh/GLbaKRZ8HCTbw9FQfex7+vhdxmmmjLpKkutF8n6n86VWSKaS9CPlp0GALvkesfrYkVmOfoi9iOtW10f1DJ0lsKvvc7Jh3y1nBRjNL7sImMQmzSjXLoWYdh/bh81yFkBf/yH1DGxpmW9O8Pv30eVKnlacshhV6X/Fo575z7/6n15t7PdrsZq0TT1uQrr9DRa1E2ipOD6h3O72k63I36r+3pNmz9eXqK612EF7TZk96p3LG6Ubxu19jmxbdbolX5mZOl6cftdDpdpHv9N7eloJnPPVspJ+GCGDS0DCOARBhCIZhUo+CoGkvJAJ9QowcJMUWlQK6YmWO4SrceFDlyeq8wzWw+dmlLFxLvRZ7tLau7Zw3dMxbxvwGtN4HjByX5EiOlKAU0QzbzQq0WNIehuxlFG0WpsMiiCyLxBB9lmbEYoxZGIUVmbA8U8YwY1EHWYIto9mxAGpGRlYhQSADd0gMMIJHRkBiISyEImApvizEj8WVWYFvh76cRlilb4m+nBawklZWci4cct4k2NStSZp2Fcpt/4DMekjYIxUu6rHn0F6Ey3jpDUHz2yN9tAyhXq4QSZKkL00SLEuKpWlaNHzYfjBMm+WQGEZmmGFGXLFCwiREMoQlCRIhjNYqoIM4aAupRAhC+ghMMOQQi/LKoBQbmSAJWrFfLD6sQjOscntIrTqyGpIkSZMkSfvSzsLKgtAWVo9gEiIRCDS8AelGiAh6rViHcoK/eqauwnzuPi9jxmtGYP8zxgn7A1fWQtkhK8N1pkcvzvExwxt8wuJ82Ukrs9aeRHUuEsobFAH4+uiLrrk8x+7/lGc/EK46PtyGgSPTnWnX3J/fwJVlAwAIML0OQKB4Hn8A7EGasV3i9LBxtboUAEFrMbdw34f3QrDnpBvMqX9gZepjVz3WNR7bg3QOyJbVq7DQBgFILQoDUhsQBmvXzv3GksS9YaaEDRqQPnzIsGNGHDdqLIPiix53WKIkfCdMOOmU02AQaSoAQNRgXIICUI93EgBtPV+J+ErYD9PkbY9cQEuxtUemHrs4CRygvl4A/AXC5tYAONAzAADIxc5fMA4ieWOVZcXnQviOocsgmyMAjOAgyQNATLau9J/vlBvuW/LJDqTbGHEjXsbrbSIrbLDFHvsc4x0/jlL/O5CAQ3dzY6bd9MCyz0q692pYYm3gwe7b+DEWyI4rhMcMsPPL48uTeUf5c+vP6T/x/h4ZDkuVJIiXfZ+/vq1yR12KfXlAPw/4DT04+ndv4zzn3PrN+/vzFZh13wMPPVKoyGNznnjqmed4in8L33eJUitWrVm3ocwmUQAA6Nv7wFqfBBEjBvE4AGSbfl0Pzuh2XHCjzhozJc606853Q56bux+yB3DOQ0/d8sxz+V54Y9Zb7xR6b9HjlvAs++RFnxXb9sO8n34p8a8/VvqrrJ0wm0P7CsqDTuBEQcXwp4Kq4Z8F1cO/CmrCrc8Ggtpwm+Bus1m9LWylyXa2c8ROdtJqwaI2BzlIu5vcpGNHp74ADXS+tmQMT6DLPqv6/OUsoOk67ro5mQ4AQHpVAOlog0s8kaKQrkqYzic9yZNpAySnaeLTOzAAAB/hSAm5nuZDUNXp56CdolfGVHyF8D/HihC24fjxmKCAPUUJr5B921oxwjYTQmgesrLVdvT2Zb8N8XB2PNreE1JzLmUH2fe8dChgnHbctvY4zegnXtVVw1Dn+la4izgk/hBrP0+eHHci0VR/B/iccOSlsd3HbS1vKXdMST+xcVVjOK7prUfT3Mo4Z1WkJ8Wc9+NSokh4in2kSjI9kakFFYHXg2VeQdvoz1xaLVu9itn8c70/BJzMYlEghObBjZ57XCvN7Vg1ww43Hld9W4xZKcKRq1vjY4tk48o04ZWjrUFGWC/NEl69hEq2Kfsd69cCIAW/LghKTrpdHKjnynWramVsCVfy9xSog8CCkvDKT77aEnif5msAm81FpEEPYvJ5Vy0IHjvf98UtH/Tr6+GmxO4DpP8HAPE9AF8H6L0DKHD4bskhKAhQJDwXYIbgx1qpAZwIbwAkwHMLCXCfMgoKXSYioL8kOJxWArJ/5xy3BAhSSgEBUIRAgAx7FgH5JjWUtUkd860G9ccYSGmi4/NEw/kWT650FnfK8Lr2VqPF0onx2uC+L0VvTVcKRLHRz61kXsqd1VYfLFZl4XXlrGqdV1eyEqVVWqL88A4XE+zO6062W1OhKXWJc+1s0N64i/b886r0BocO1XG/DT3iyWozOb/VhXedQqMtDufYGO1E6TYqMDso5eTNjZE7i9a2UgaNg52tVFbLkvkSnBC4Yof9JV4Nwplzg9uoRaNlq4OrnDDA7pzH0+Ks5U5xVh7RUs1TChGhhMWca+SIzqNnjy7hJqE6tYmaSAPqQLuiSRyzjGL9aX0UsF6DjBklBCIK4Cr0gLBE1eYoIuUcc5FSGAKnSGPyIW4dY9EMOUCisjOGdfPB/QjQP2gEvPrWFG8ALU1lg1cvxcO7hmu0jKD/F+ciyb+qINbHvs6EBW9I7W3UkQkjceCZrW7im8r4a3mouet3GqLW0+2616gZVpZ8IRspWi+CoC5eRvbK6PoDk9TqamLBb4hbZ9Ww39T7st4dUPcsgefxq7LUxvPi+gqOtlwaknZqyOu7HCNtE5+gVfGDktf55WPsdFkAWdIuG1Zz5TwUBFUo12oFCc8itDHqRMaO9pC/j4Ey4vUd/2djrE/9VkIegyikB88ll/F6HoyuqO+B5fOE5C1du2tMHs7Ip/D5Wx1qeOPT9vC106oNPIlbDDo7ay2RLa5gNefbhefsBcztUb30T8CBccu9p54N39aP+UadhHEmKDCzL5n+VpfD8PVWpuEgxz+ZPA68g69aWOnfCa1eR81jfYqc5+G8W2t+d6StyjXJaiGvql0RI/YPpOFNLbXH2agrDk8T4uwjV4pgF/5quTlm8SCdq5s+DwEicdWW+RqEt+ey5UKFqxDx7M/JU5aNkn5kWBbdf3bAKNFl6WxZT+VcR6mIG54/HsrIZoWe1dXQH6nLC9nbfZbihYB6djCn5c6OwXKZl7RZQXEkhsLkPwSrxUOjWU6ym4rVZXeayYys315Pe93vKVpIbj/LuiqegFw6EQR0zonZmNr0waW9Ez45fLoCWZQliddzPvrI5GcKKk/0KLXCHqu5XCpu4O0pFix4pMYTOezL2TSLZqGcdKii58J16IqNgGkhQEd8YUeKfCXENZqJCS0qWGUaKveziIOAq8YSgCqz1hDO6U6PIiXglojCUkOebiEQuCWzBiy7eLctF1AZMBz/k3bDCRAKYm3D0FGLqKKrnikddoE2KxFyTSkLyutzZ9UZWSbEU7hhokAogicEve+oiUEA5enk+KoYprrxXziCyN0h2pnw1t2v5KTDH9i6QsmSGtKxhwYr4k0vhD+4qdlpAIaPXEfIZ/cn0rmYZk2GZFBy7vwM52SJLyKtnPBAbe2+Wkef1c/+bZR4pHGkOcGanbbLs5FYSFs10F/9kSJ554ntkW5OdGFKBqqOnPApbm1lCaBcNBRpHHSHVdUhFPb51rHGUbmoKXZUUe4FfoSCdNpt0fidQITN1EYNPvDHtFP5dMqf9P3pjBWcSazCxRMbY0dT7C6aznz+SGBtwFoPiIUObQNvTLQK3h4F1gISw0GbxYMHHYzwRCkVgVhI1jkoX3YfOa0x5RJy3uuLAEaoI+DWVJza0hAKowZDK2BuQ57x4YlxIFbDYF5aw9CXETswBDzjS+dAjQVIUJCVTo8KJYqpqhdUviAdxf8OALJk9cKeAdkJlgNhwMk+2qfXGn4OwlzjA8xSliZSuxqm3BVDu0URVpwXe7E6oeRx8Ia8tv8+XuKJHZdyww8CgSmIPporAyuCXfsNHkTKCER9sstYDYZFM83KcxYVVIbv8AuN6K1An3ikaqRqYojL6JYQ5IV3znkSUsVYNyJptogWlWEZR/+lnTEHoNijuMUZurskLUB3RGwm7tG5DBGrvme5feJ/PpMFg9d1/nuDRrPUItAZGaL3bhurmVS0dn5Ijoc9YWPsVzJyJpEcDTMs0wN3PUhWWAj7fy1cI9+q5EpD1pLMldUVyLq7VLvN0dAfjHR/4A37mQBcBxGzP8MHJCqteQRntgqfjdF4siK2xDoJ1iNL8sD6wvcSo2RJF9gqgPS/4DsOifoc4b7JRYIyvNW6MbOqLUwloCDnz7hXXzWvThkRy2PGh5WbHOwkZvCNt+OrY32NaJUYu0W+Dq+/VFlF5v7KEUqeG37YZ2w0IjjL+RWdGLU+RREFrWaXgziazZUs/6m2mkjqhu8l8xQXKjZgMcCMwOKxMmRUZrZnIOMRjgQLmuVHR9/JPiUHWGWtNt95nmiyputv/UpnjRk40djUldIRXv+1kJclah6QdWoPMmZ1Gk513AH0qdnwDWuWSchwVj+TfeoRiu1fWbpJGpQVSFClmJyZ4raBDXtmrlqUA7dsX399IVNZbDVyv2VB5lmWVDdCIJrfr4wLRNUNFb4nn9NgjsN8In9YZTwC6k3uCSAglGYk+gJvaTYVSO83i2QZsaYgnJrcwJAQ760yWWUtSUJk3D20xzST6IYMIIJCGHtqMTc27tuKdN/4jUlttCnWaU+Y8q1JEwgANmSyCKeYLA7IEisdaXyk933P+WJiD1rgFKpv5K7+74anA1t33jNp+6Xh2jD5GdbY1hfqq6azmNZWPplOO10hy9MU05+i1dqjecemdLelt7nsyAz1yFm2+ngc0lVaGROgdZ5R6Ao6G3o19t828/3xv6WQt+0Mj6ivdOgG5rh7B7xwa3flRhysDBp+9mxC8mnXC778zW9X8WlBKQx3L7a74yGfLf8jHpEcwxKfY48fn5e62Xnjnsz7H//gU7nZHFYoOwH1rYU3OlBZPdpXSSse7a2sGuurmEKZ2tC4lvSD9qaWdIqhNc1SrUCneLyvomqsp5rGG+mrrhntL51CGFKdDA4XO5pa07jWNHPoW4UDISmhwqHYrjiUO9IUYeFJb2Ecezp3pvfBTO3YeGGc638alMSKH8r54y/+p9kzuyIfPkfMryIj2MaqDs4sh/BDsdEQNtnhULyjXj+BGkKnUw7auyRJkmOU689qzclluCymt28eLDMzbKuN6r2qrabTfb0+zrCl2HRNP6Me8QoTYDSf1/3VvMzEsKWS03sZxpP399ysjXe/oSmfyYVt8GuMDOOKMYtyyiATy76GDdY+TDljznoo1ME9rXFSoSMKtz9YJxIV2YJt4aA4xVil89FNzhoWVulQ2vtv4CaIjfmg1vUfaZUklVVpy2baUdlMWxsfDxrVx0PjduYzPO/AM6x1grf2v+bbW7+N4V2iuv+bvP5tBO/CKZwO6osMCzgKDwRNBByP4vj2Q8doeLw3i7Pu/UyNQl+68fR7QCS7nRoYGOsTxOXFqhdlv1rOrP/w69n16Lh3xQ327AQf+XpWa2xkjA8rIpDNiPOm4xMOn3odWrSMen0lJH0wiHB4f9p42hXF1dWX0ouX8e6Hw73Dk6K9X34+UmvSs6t/td8Eb8IUPa35dWrXblKFFYyzr7zL+EjcttYwCjNIerAOrVSmvH1zuLnwAyd/BpGhKugdHcIKiqzIy0wv4IZ/Px9jSJ7aUr4Kb12XG09MPjH5TuJt1eHF9zlVS4rmIhGbExznG6/B6nO7eNoIqza+J9w3oS45NbHWz0ZGXIMsrqthc2NuDUmyLDzAiexlEyP1MibSrwi8vyH0YSY942SELpsY0cu58PP1k7lfLzEkW/+YeF92DDfANyo+wI8To/KK6RXm7uYVzDrkFdnHiswlJthxY5tnlgU/VGduvSusqHlXnSEGRqOiIzsdxOzA9uc5pnvSLoRal1of1+13KK4jLTW6JQCNZkUa35InP4zZ8DPKy1oErWVvZLdbaF2KtrkjaxAfs67eQKycrPdkhXX/qS6TEKPho/Ysb8hFHZr88uzR3Oq9i0yHJj8fV0cHmnCgqbKetbdnlbdnQNM6+gUKiHGXF975Ea56ZtLVbILLu+s6v2NvS/blg5ulSdUhlmt6lkLOBgxTdsZT1CiGTUkhzxy4OhohvCIRaJJvwji9y1JV88jNWWKkYOLcmQ4RNRHsx9MlWz9/T56erDbPSxQusC5x1D3EVHbd+zx6b2L21WyTPIJ48H5z/CJfVl2Gb45XjT6Do+YDFP+vkOSda1ExPYGacUq5wxmPRJ79hITSSyFOSojXrVlY6vHbecSJ4ATPzEdNLrWLmDUjMSBvkUb3elRvLnXszP8kMbmvBOEKXnZZU8NT6EPsRtWL1vKSbKFCwo98elr7+PDBu9Z3B0x0RieBUNLle7X884vQE6e3ZxdOmBycT7Xg9W0/ACj+7NceHwvWppBhwSBwwamvJWnjG3TFnXMN0OKcuqzc12oMPQ5+WXdQeugCQuOH4voubGZJYtqRzkUw77s4ujo0TKX+lnxjluhOBAQunTu+McGZ7kxwmvlztyqEJ3zC5/LDc+8SK5ehtWfaUV6hgZ6hyTFEOrVtsKv9ChoKTiW8jUfy8NZ7Qx1HP2dtD1+4o724fr5cCE7OBlcGUPwDVSpj8g1ms/KFpiqjVUM6e7njAGFXweTk+FvbVT89vd/Rff7ss2ZrxfGzp5VG26zAQ9qzVjvFseg37u/gqQ5Y7N1sae5dA/PUd73fW5u7N8A8bRRAY4dujPp+pRa9rny66wcC/UU0NTMuIiqrIBbCurhfOXuvgJDkvX15coj8i2ZM1Dgq/Unm+SemAsstPmrMvZFPobiLW+EQgl/iMxJCw5OS07eDDd2ymanehiHexJ9FH1MKz/0Kbzv6lcv7p4AQkhWbEJvOdqRW+Zft3XFc/XjsssrTL0PYwzVPKg9s46JSPcMc+y5PXiZcPve1R8cJxZ/6tE8GsRNV8Podwkx1SX76H4TQbbO2COk+qrPaab6xWiPfycgF6hO1Ed0vTeZriz+efTu0p0vcL+ohLIEU/huw5+QFzHevwYcTb3zl/tyob8TzabwYWgU47WqayscujC6mfZp03anPb7eZ/ANIsftfbY7bqRdNVQE0qeodHwhs83cBFF9rN/rAHix42nHifVddsKrWUkb2jN5a2vf00bvOopYxmK+mP0OKGh53NrFkE9l5g9KIpKHOB2crjv89+xkUHXRw9GLQ3W3N8H6JnY+9C2+t3TrzBBzZ6ywpdcsiyqjzQvQLsUZg4GCbbj2PRb5Rv8mP4IkmIAEa4LWCk3pvvFcXxCH7wpvCy0jcEf348or9pdKWYcQ51+BDEE0CxCSfuReSuSKyG4n9T2jvyt1vS9CUBMQIjnAPDavrVx0MrXWy3PVnfv/1jrDkPeoADVBiCVG8Y1NLBNyPlsjuUJ4Bd4TMLXoYHIDd2qfxVbk3CyyVNbz9KwelnBCLrMiJHvRNq+yw8HkTJlyQ5slJFI+qk4P8gyNSJsO657rZZx7cumTqiYXfGen3Hjn0bO5ZWKjNrn83dG5PBKWLhKJlq3Ifrsa0p37wM7bPGY9Ka03MORxPCeb2Xv1M/B8nWJ88EF5oFHTTOCgvImW4QL7+WkLpWACy5TR+1NeF5ZtjFAjhARrg7bvUKep6cpaeDAf7QwxLKxajjsUwV5SmJJ+8fOOkgzVm0UiroDxVtjXQ5PnUyOHnifBw+8F/9xmGVGkbH96VoRRH2y51gAbqKnILFMG0hIprD5364vse80fuzZ5Un2BTPXzydTPAEv6EH53hlWEQ+gdPSZNroAhmJtZcPT54G7p1EX+K7eLue9g0/Dee4mG5uzvj90pp6ytpEYlFiP6vDGFOdj+ME2hN7ImOTO460ZzcH8VJ7LO1foT9b54w0xcS/xcPUC9FhSIjsoZvvdFC4lDNnN6wEr3wi/qckvtcy90781o3xsIKpbh/Aeql+p9gbs/M4n7cv23R3cFFBpFT5NDCkJjuGMLX/YMH+vRir+EpkgK5ng2txKPUc/vIEaaJcnmuP2u2pmdmf8y04Q+6uDLpLpYkojfl2T664gLjfsOfM7dLHgWkDgVJIRwj3bwYHgd9lRtthM/PnVc2fWxJtHvloeBNROlRO+Y6hD1+xHDyLo+duQlNX8dfHG6tNwj9q07BeCACbj3Xlp2jSMvOUbSNLGdKK/lykjaUL/eG7g1tS9pQ5CrGr48/DBD+cdqKTJK00DKYZkwxDC209CQNGHDLzS4DJf35tIDH78wtpF7x3V11I/EsuVNmhjYXViRX8/n/d26tBY/Y0cPDQ6JvPp64P4a4MXf+5MeTeoZdDkpOZdDhR/MT3hM+H+eQq02kAz5i4wA9OY7FX28mI9bn5s8cOnNo+SFipdnIsGtC9+Q8OPsMcWPs/sTDFwK+/kEHHBkKF84v19tnG/V32FGowc5PoQunPjQ555j0tFqb2Ec6koazt2HsZxL2tKa1D7PCh8nLsj49N7B9fRioZvpRq/LardULKo/V5mVfPsRfUnt/60OP8rk3UA8GYgaHuYWFNoBO/FBYjQfJHFWWYUar3NbYZlMlu5FtPRut6Pk7P1bvz22/n1Zjenq5WXkGBgjOkzeSrDFRHdl37rZn5RZUVPNKgtuu34vuqq6bLSprWhNmrrQmVdezRX0Tp+POTGBbWQUsjBIyUqLuTCbFxXoc26SkRt26nBjHBcbwZqIenPmOZGx5++U4LhE3hpMlyOqN6SXqjX+zum0SnyOmhFS6hfyBlKfPfDjTzeKFXhiXuvEFUn1yFwe8cvxyuIn25pa5btEh52K8GzmnutnFYedH5B9++inx4Tb+0GFOVGyqkw09lh4feCXGt+Vhgv3eYFt3+wytN1Zu2r4HvZ2TtXhyZCbZiWZ20IEe4WCf6Wj/kGTgSqOYONPJ+of/KqjaPvJoGeu2uDR3Kn5scq6j93hf49EAH3cWO4QHuBnJoTy2l5drUH/hQKOy5LHeTkxvm5pHqxpmwEJquFnNDTN454KX/Y1c+xsXvO7cu+xNuz41Q7t50avRZ7o1wtEtMyX/cGTsYNpoGCknyZKmRzwuFjGWW1LcVl1kGqjg6p+3h7FrqITjAJgmuiyuqWTKLWTGiLUS8znFDbth7vLw38VLb7dmd4Xm0ZJsLtdslhjbh7ZuwrTNdDlaWjm1F5XY+5nr29lR2KCyjtwvMDE4oSCwwE/o7o6N6eha6jgaE917VEKQbGNH1rdx4FAdImhU3X2MMdo2LfpPtMu2y6E/UteRAesBlqdao8tUAZfIkPPw1xvVmU061l7c0JWbakdNjPKsT/D3kZSOd09laZTq7htT+Sds6HBB7bGUqFSebuOe6sgz2Q1VI4UJs+rWRH1TGw12OmDXSw0AE2nyeqniNUpctmtKcKNhxG88RQxlzWKVhFEJ5/AA9dKtTNB1SfDP0ydCf5f2ARR/f/k5Wx9mFZtZ5uthR/P2VGChhxsV62LP5AygB7hu+6xU7ZGqVUSJ1nu7Lu3pSE7DWgqEBHZNXjGYmhmgdV680t5x+WrvGDKIHePq7B0FAlwD2TEuzuzoMDLmSH6RWW9HvRFVmU5ob3Xy9oJc8dDU9tNHT9bvXOpsaQlgK+8OhFgaulB8JJ5JNSBPzHFywJGhq8n/teEpHvRjY0OilOMEeRnKGWdYJOkZveoMD+oYEA2C/Lc5kaxDNmK4F1RH7cu39ai5VLV97UqEce1ztWfGy9zoGReL5ieuMyi5JseJ3MlvNNOoMmh0XRqyWTPi7LKttm9zzwaYZyqG8kWWusFWbM493h3pr5+QX9TwAMXHfT31Ljkv+Vp2ahzkNYR3ev1zc35q6cZINGfUSdPU+ZBTU1HDicVrz9za1VLJC4GkdBcGzVzbxtPNsjG1KSDmlIsdy92mEznn7fRe+mdZnbnNPaesC09OdLf/HPkChowdXZlO7n52+jipRuSlB48TY7LibkJz2+iV9qPCiWXpyU75ap4Ex0s0w6fm+tw53URC0OU+PxDLMDNytdLV6/OOThCNzlb28wx9S5ZR+IsCxfbHCyU3m+prFrNz35csfxeeLYlyIDYncSfTneKbAxKp9bu9323qnCg4Fu0YP/LS2r0+PqEhj5taFRSefqrD20bPBLmE7FWz8WbQqGx3W2svd3uHQ4y1Q5dvgnwnoR7KtlXdYY9uNtj9K0NY83dVoNZ3hz2ercUZ5+9xQmDN9nMS+yabE3a57Qi5JzK5K8L6S8psG8z9ow4EutQ1hoY9N95pCuDQ70ZeheTQKXIE737YIJ6CV0m2ACkD2PQxbF2LMDxkNtqEkW7kZwxgk752+5ivm/N66QEqfuGiG3FirKbec+A4mT9wscl9d3f6f8tlrcvlDUVNT6Gn36GNjioJbn5mOLMI50ZwvkAzfmGRulreUNrwSHofAifQxu2J5sR3TRxJ7OVExvdS+H1OgfESnDjFQHZgrWHSiujSkZojNfMYLeyQsUDyAc+8FF92fhKLmZPoH5iVnOBO6AjpIGiPBY3tMwj9Fl/Q4r+7K9zwtZIGpD0oFJff5q/qnGr8SkEDp20luaRe7MwshssHF5v8Iubwohrba0seXD281OYd/BB/m0indMqC609vgX7ACvoH+8Cmqkkvgjue170BAnxf7tD0WGY9XPvsKd6B/ENeqPH+RBRkRUTnZkAh+8PzMzmRhRlRck4in6ouyBVh5YouYDAn237Ti9vqT9WYY9G3Vt6sENZwHumCrKurb4v0UNXYzlAuFNBTFPg93DKcOdwygvltKouOzFfV+OKr5qOkiHNqccl0qTdX9/Df8Jc6XSI+GT3o7o/XH4qnKXu3ApWjMAfvnCQ8mXsSVqxOUS/St8UxheyvDdILR6be8zt6QBeX78w1u6sB1Hd1vxpTDSGWxruSGC0d3f+QMNcHQJ2iPjOkkxuYXLvzuMaLajOAwjGFHJjCqFXpOB1jXZi4NlRmcILc2jVQ39jZD9WNtvUO19b1jhy5K9jECUbwrnsYWOiFwqU0zBNEHr3UGW7LGmR1/tPpLcIL2ZqNne2Ze2LvmUlu/tnjKs1bsy0sLTicMdxSnneyEAqZRdiGRsSTjpvp7budoNGrOVSXyxT3srGISimsSk86frTkyEgP3GD24OvaStt5F+LujKQDlma6wREnuu27nzvEDg3kkDrNE2INc01yo3vSamsG0qLz8ilcY25Ee6pwR/L5i26ccLc9FUSdCqko+iEm3ekQs+a1thXJNaM8vyDtxEBBTd8AaDF5/vr5qmQvx1eFbME4ao5ySo4kUGwNo5KwWAwWo4Dtyj919lTquv0I1nmvamsnzq+9tCmc1mkofBWCFXrpotipS6hkQvU0ISFYQ3Fb90pBwG5SA7TZBDtJohXFVlMNDTAbAezW9heEQH0L4hUc7Xy0VW2tZWC8jRbdcntTI9gEwHCMAUWe77G+A/+JDgL6E9NW2KbVcDoCNxuiHW3sdP3N8TOLluseQNglQ1EK6pcsr2/+vIKGtSoaWmSe1Ky0SLX3QmB58oHIywD4iYhBPCqH5TE5Io/LUW+sLtBAMmKsJs9mmyYBGXgTJ7drE1e53LvGjaYvwLkcz9tVdfNvjaSl0tu1sUN7N9t42owxcXIrr6xSmOCzncgeoJw9eJg4GaWyaujHUThcnF6KtOJI0khFkuiRJNFdSaI5SaKlrDFDoX+lMY1JYxp0xhldmW4mVMPZZpwPSNvphl56whn75JU1CzsClHOORFzhWo/4F6OSJehimnsnoPMlRKC1uGpXzeQd5Mq15aS2US6mabusde7UW+OwZl7WPS3veMeQQm2SQa4hhnd4iOGdEGJ4FzkvKjVLL3IMebmD1zrcO8/5BpB81rd15h54liC0iCQBBG8HaOW9TbpfAYCs8b1dKzbjVfXQyZh2Sl757MqjmDLzRLYJBVDX9GM8ANQnnc8PQK+BuqglPKovLcSER3+UFrglnyi0Olpux/wEQNH43pPbXuRoi+nOR43KmOjnkKOFeZStOaFhF1ztl5EkMZEKCayjIsb01xLbfkd3LBAAUGfNBhNJksJfTzXPVbrI3/2afAB5wmw82Vps5wIAfaBFYx78zMwxDjyP0fpnZ7Hsi0FtN5N4jo2uPRtAksqEQdLMeoDjI1pSMID8BzaXgEYDFKP+ujk058VqlS7iRzmjqUtQnQCa7HNjCICe7dt4Kg9+JH+04/jxV7Q1/5f4X3qifPyzqr2Ei2oAncXAc+lxKlpSolAV/z+yEoohum5d8svTRNOA6XB8cw7IA3sgSKVq34OjakKC5AbpD9ijUNkSDXIfVtdAP34ROIdkwmA5DBq6OWPx1729Hns+8C+7PAvSuGLdg9wOCapBd5skkcXORSvKl/2YWJyjDptjEaaFPdBiajFmRql4Z+0Gr9qlXoMQQeCKXVCxE+ZakyxbMoaZfhC1kDZ2EV3PRQgww0k0CyZuTytzSdKTfOCAwwh6qBed9GvKTKUvex9zJGxC6tTxtYegs8zVmPAgK7evWNXlxf3+JfNC6CTmX3R4ScpJb2lRkPSPc5yzNu+gs3RyRRl9nQX3+9H5nAIbpiGQ1LtwXlYeax6kf7Qe+b68i28MA1VT6PydLS4EtfQiUY91Z72bWSCu7M1V89NSwSe5BeHZcZNVvpe7S9Qdo0ESHraQHZGAVXxb7hOkXqlIituCfk9gVkqRiJlWKt1jhRVw7z2XZFKe8CeYHUyqgR1fYWJVN9kA5BEb0yAbpzCoEAyM+UOw7LZGTs4SvIADewP4TwqTmbIFZRGcepJqHBAZlbcavORhSAKDjSSrElXz6oq0UKFrk71PXM/D1zymaBJLEr/7NSTFdyQnw4zubdVKW3wmP1fX+EGRxT35+Un5YDFNrEcFgnop2ss8YplartCUO2ooS7nACO8lUU5EoRxkEcGHMbLoxT/uwXLd1+3HQGoEDo6FUtkFQYa0ScxvL0gu9qGrU7sLTTfI6O5l2y36s6nb1KMgwA/sCJpIDZSep7mR2W1AQErExR+Av5gY916hGDTmXXzBEyKiHQAjbtW852++TfHdbc4CzPh8+7PnqKfJCjYuPI677Yf+/J5fisoFa35jnfy56oIUYFCjHtOpaexHZ5n063Vws0/Ks1OHGcF7GUk1iGOaRS88XZJYLt5uIEKiBepQ54HEwYcI3klgq83nTB6lnlDncRg4X1GF1E7ubqFZvvrZBb1aXSHXpWVxQ3nwmHshCvnFKe3VPssn3ec58vT4a4+Tt924nW7Cm4yyMiQbPxY24mYnZhSVYlPhkpT6AgG6LYEcllEaEpp371VloGmEkz3kV/YpPvc/e1Bkp6/un2Lp85WxOu/7kc31+K7P2TvNG+l2+ymF9KsSQYwlsssOxm/w2RjtBaHENUrnNvtsbiYx3SyYnWKZm4JychT+In5Jg/n9JsUr89sA0y8JLfenAnJGk7GVtqn/Bd4pwvhaZdbB5Lezk3q+CFFhD+NZZRtYxKjKxeLXLyk+Lz9HCnm9QOoly5IbQeYnjw1TDyuW8guSZWsG2q81bOvsstLihX5KKLtcZsnCAvoeALCde9mlIgSULkvFkMUyTGAqpgopRTO9nd7DIDwgD52cXuOID9pUzFYSwL5oqpqLsS3d08iYPRMAwGHwi5QLuXbDK4H6MoqoJ3Zz6LF1M2F+0q4wbTdDsLBcjYCAjLFMvephkiHfkOrLCE0Si3u1oVW1FEJ1xNiaX2hIPvQRRzcDMqKslCuhRRAGkGfd3H2O+mpuHYK5Mm+y+XG8Pq5AFqsryZS1Hxf9N3IOKy12SRGiAFfPXgyObPcAFiFQyoWsrTIcTbuTAMJY0ZMAA2lJpkVvLdsEtYA7TVVnozZ0sQ4miL6gU8F+8SgZFJ9LFUIOolloCrqz1Z4JfK75QbkeUfjjKF4onPZETvRuYrzCsU3XPQ6JHVCKOkcWFbZzAnCUIUKJPDrmOdBSPj8EhM+9tP8sniirrb2J6Mm+6N+zj9oGVEBSXF0yfUqG38sbQ6g+pPv12nBlSDXLrSycwZdWORfRbIcSNQuB9pJRY9Ti0YUkt2l0k5XIPENNW7IbXiz5ItIsGerlTTmSja/klY5XDPVNP3A+twYWj9FeclaNbjJihC3qwTxSg0Nqct5oCjFKeUpjisWf6y8NNJ7idffNZivrnFywzQY0lkpKZUSMn5wKo1syBG8QgvlfJgqplTIV2e6Jmsglzi5nT+kMn2FzooyiVmDIDzqsuM1i/XDBrlO6iyUa/I3YcWck1uhZMk5LCI2B7owhgHIOTI/WVmebjgTATQhQgYimzT33CRfFUMn6XmKrEZCH8CNnbQMkgo6B/QGSfVFhYrS8ZerSZ0XWpO5WMNZkBv0xy1wQEG7uNZP2Hho0rpsUG6KXwpsSiRVCNDjL57B1x5QAgJ0PJsK7U2BBsPUVq7dlhqrCV6vNKfKSKwR3Bmi/IVBtMmKW1r2+97rMOuQyAULOiGD9firqb8yABvI46arW9O+5mSX6CHSjuaSKbJk0UPJmAXQZZW5miOlipiCN0saXdKqVRu5INrxiyDzWZpbLNFVWLV4MsUp7li9Clu0yJHl5z2l0HsnmyzVaIrxJOBkXtDZtetmhhFANKHWEmLbeaoqt4yHxptgUDyOumBXT2jTFw4grelfdo88i5q7ucS2n4AT4wvKVDcGOUkxpeuhRUj9t7cjCyqkifago0fDMFo95ZcFjH1QvqZeVWVGl1vfwuo2G36yzahnYpSR1jYLIuTMvcdNymJhxEHwAflY+Wn0Ee29Ckl4bxwnEfMwx2CWRU4f/OWKYhGiqGQYnrZsfpVbUtRrccJtno67aI/u5tnjJTJ+VzALDx1hL51mX6WpYF9cqjf49Qe+WGNYl+9wBs3nn95iFwvKVrEUn6Hv9Q3e2aYgQpDchJB7PRUMJTspGqEuGe4kYNYbkkC4UmpnxmiW8kR5jfnVA40a6z4mFJoQY0qeCCdJTpXkc2mwWVtVdME0zt/I014SnHfXmMzanebb4GMebqSLHszpGsEHpetKkf/HVX+4lKu/ipz0G7up3A56ap23w8Omi9fM7wtNTMaLvXA315gHQoV6W2gaBSLD1Bv3WBUa6sF3XXWPRLP/ShZ4a1xkwAOKdK2iTdvhfyvZF1wUAf3/cW+q5Ddwn6IvM0U+qDXaXhpU+Glwbe91hYp3K49LobH7kLEFtvSKvGUtj1GNmgxwZJ/asiP32fQrYt44W8mQePfr6k+Td1Xdd7DYCTQ/2b9Pum/vgLzwjADlHgs9poG52B1UddqNSdc03uxcklWnG8Sc43ZptuUyQ2JdpLwHWISy5y5nNLknmJfXBMV26N8Ffil6ee998Po2yVqJHP4b0TeSRyN9EJplv35O/6T9zRXv7E+KaA4bTvM29Mh6S7wxfxT+moEKVyuG7v5bMtF6bBDGtPbxWzc++OsmCWT89mAhSkBCW/P+kQyaKUMr9aZIO6ZNRmZHl2ZYjeTHv5qtcz9/JNISHy4f7/NqXVV3KpjNdsrGtTb/grOy93ZiHdxsxuI+afrZ8+BgE5HVXhO6VvLygKDHHgSa70dG+UKasfeFZaYVcJmD1yxOKapcb2zZtTW1tmDeQ61NZDnRw//311Gpj7z04TkiM2PZHdQFLtCRXdUvDG4YE8+uCq5Itv94aWiZB4Qyy91ZVNFdlKp4cw5CCa1DCro531YW0DfotZUM1bmo1Blkn3Q+0s8hX8YzA7hWcinmMW17VCRRjqExZ56Sf1pQVbJlTGjN05sVBQhm6HgqrFOCHvlgQMHzD6XKABtXVo8StZvcpw81CwWkanURyhOGzNHHMhoilqeLyxHOJOepfHScP8u69XmbJC9OJpjjhSIetVJK0U3rOJt5Y/UsNm40dsrlt5R73dP9fiOV+Za80Xt9DzYtGo67yAkaIKze8RMyf8NFVPcvxAFzGpOcZi2rxxDvS49IhmNaeZZhVOWeq9e2QAZiUa2SOfI3IO6+6c9sXqx4c0VvxZsKEJZ5PE9JIWHjk4nCRU7vscSgXHJoFzxIqY6K+pOT5LHok6ks1vUxPz1fsYdtp5R/GxE6kAZHVEbbZTm/ulMmVrxSa/08+WTcEi3XJY+GVHa9B6o83kjXvCh94X5NNXVdYL7KQK3Oav0KnxJuTYweuZLlojy36/uZqc8g39XJ4k9HaM3hULih+q0jhxanGCMfa+C194qlXJEeQCJEnhZ3kjbRju564A/tfzY+ZUgrdt493WlFeq7xEprdensL5WtB0IFVbfciLr3w05BP1QPsUqbp9NI1juJK66ktngRWUoFCFvR0duSd13UE65R+OUtlTb27lN90umJDTYj7FJSoCuPMhiWRCVhmfdQboRCW5u7brpI4qc8eXyGNX99PHZBBBHR7UI8mGxwDXJR/X3vpmBP9kRwV51xA6PEidOlFDOwrvveTgr76stiTRzyBMo8pX0rG7Hdf/cwrJuoWjBnGSHXtHrU2nlfub/XVYQEMo9rWoUBdHpvrtYu6KEdH4rgnxmAfzFq6Lr/84joPjGJc3eCnee9rsIkL75JDLAnPuvDZJZ0+ohmHZztmSP9YbXMeRXKwnKgs9FowOdKRzXGQQmaa6pd2E7lLbtfCZ3RZVayNOb22FryN3A9xElJtPY5v+yEToE+oauolaTmbSqKb6kG0ULztwi3PvleKR9+Tx0Fbtp/7H+OMEMZ5NVwMwKZWuFovWIYG70uNNmhJ/WJjDKfP2qFHpBh1w8hBvxfuzGpyXXKxFVRaerdpcnsQgDK8+j+QsuF2tYQc2LlChWmR8Z7wt3iel4m+Ovo+EubexodmFBxSUi755fO4BcE/0BV4iQa1PhFB4a7FWrGL8a7Qm0prJj7udK9+db/ww3insOjhRqDaB1I6h7QS8PVi71KrlkSpyxy2038aY+NqBSm+tjd9FQ22Av/aOfm+Uby3dl9sCkstXvG7SGfyDgV4w+kyHB7x3yH2bLRJmhOyUxkwZ3Uxpvu2UbPr8YYw5MPif4juEGu+Q0KT/401GDwSKeHjzmsNoNmAFD+wHPau8/HC65gfdMokfKhUnYe3cZ+/v4tYCaIWCu2SoguKGqhxHUru0Ma7Z79uiT8HhhoJ1gqMrc/v1+DOSmtNoXQqxMZMnVkk3S9y52N/gdHrwbDJ+8kHP/fd8TZo/jKt7GxR7jl4oiL7aJa5FwmCXY4Nxia0LiA/m09VzWxXy1J5FLGhuqLax+uwfTBqAf5VygaCGiJIKeBiAeOB2BxbCawbxWiaCqHbd3hhG9SW4Twmh8dDqmtl4EbTIV2ZYevE6OaHn2dD5eiled0w+4a3WqQ7PYk/yEQrAumfKKhwzdoEAlFQCpkZb8P8Jsbb/+PSnG/8W0/91U8sMAQAAuPavpDYAAE+a+/f/Ef88ESpekggiBAYAABAgcNUqUQCEHly2+pcsVAyCh2xmhRBDaNUFqxl4T5lRy6Kuqe6bsfsK/26B2hyYx335UR7Zk12Uyo9x+0YjFcUGQ3b8GV9rjb/GIOxgAUNEIgRm8H/anmElKxQYlxSDalBS6tLytwPzXg49iEBXkt9NeXaS/MpVIugWeiK/Pig/mBorzZ4urQUzf4bNAAzP2L3zjAf1tax1tvXVnm4jqZsQmHbA9l2GbH0B1wv0MJaWAQC8QCxzELIOFP30y55N5YkrAqvKZ1UMtHhLpWrZ1mERoSYmpEd32YkLNdnTprjKEFk8VhRRNDPWsa0KozhFOLzbEgFi/QPlkiJTSICI4fbRhxhoMPpy1DsRJ6zkVqvgmhHcy7iVPeFAgtwuANh5id9kxzMrleYOOLoiZfvdFgyGUkl2OfKK3wz9/5wYg0JrU3muc4hIFbFLUPxWnENScgec3CeFTnI8plR++ZvtXAQuC5a9gG+9VdRFQfE0w6paeVQN8ypkVWXiQxdvnhIwG2LkTxlxTGq+kNzFQcukJKa9E9GeorT/WaU5btqipTGreK+4ryuKbNHB4Zq1VOM3cjXzqgT19ZZ0LVOZYyZ18R9DFIMKIsiwhZ0jtQXW8RsVIMMWdo5Un8isLQyWNLrb2LDSgA9gLWIrxQG0cSHDOmWMu0Yt1S/ATiYAwDIDO5VgHxPSQ3cMJeOljHZXm3X6BdjGBMB5IUAA2FJNljPUKxqJN4LB+0H75xMUBgEqIQCAH7CeBBHlNwkmiDMJQVbCzMhJKLuVIAxakmOPKs7DNdbicKVLEClchCQ4eoh0XwqHKi4CjhY6IF2sYNrGMkH0dHeCTfRMaAxCJUhhP4R24scJapEEK2kaLZhP3ThwT0pmokjw2PiCdi2JIZNkog1pSQcgdv0kXBQ6r7jU02kLxBUoWIRQ2jhbgnA6okUKFio2yatJpMMRnTVbzhhsHYgaJkK4XdwOR4g75K+x/xXYb6KJwPudbbq7NAsJILj7a9RmcYCZpZvVp8PaW2diUzSmQ6UEOBioTIfWVJOXFKkUsDLYpxo8nSBFR11eIlfIgOCmE/ZxoOxTmEbk9z9dCbZdwISoiMB+PvgzNe0miOJQ4gQf0yFXW9JELuIWJk+YS6fMH2IO0rElTbiIcWK1OC7uIDUSLCajZIBXQv6IN05+FHPYJ4fUbEkT/mK1eF/cYeYhKTqKLA7JOjicZuGgRA=="

/***/ }),

/***/ "./src/assets/fonts/KFOmCnqEu92Fr1Mu4mxK.woff2":
/*!*****************************************************!*\
  !*** ./src/assets/fonts/KFOmCnqEu92Fr1Mu4mxK.woff2 ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;charset=utf-8;base64,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"

/***/ }),

/***/ "./src/assets/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2":
/*!*************************************************************!*\
  !*** ./src/assets/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2 ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;charset=utf-8;base64,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"

/***/ }),

/***/ "./src/assets/fonts/fonts.css":
/*!************************************!*\
  !*** ./src/assets/fonts/fonts.css ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./fonts.css */ "../../node_modules/css-loader/index.js!./src/assets/fonts/fonts.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/components/cs-app/cs-app.css":
/*!******************************************!*\
  !*** ./src/components/cs-app/cs-app.css ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./cs-app.css */ "../../node_modules/css-loader/index.js!./src/components/cs-app/cs-app.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/components/cs-app/cs-app.html":
/*!*******************************************!*\
  !*** ./src/components/cs-app/cs-app.html ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<v-app v-resize=\"onResize\" v-if=\"app.isInitialized\" :dark=\"app.project.theme.dark\" :light=\"!app.project.theme.dark\">\r\n  <v-toolbar v-if=\"!app.project.header.hideToolbar\" color=\"primary\" :floating=\"app.project.navigation.floating\" :class=\"{'floating-toolbar': app.project.navigation.floating}\"\r\n    :clipped-left=\"leftSidebar && leftSidebar.visible && leftSidebar.clipped\" :clipped-right=\"rightSidebar && rightSidebar.visible && rightSidebar.clipped\"\r\n    absolute :dense=\"app.project.header.dense\" app>\r\n\r\n    <!-- header -->\r\n    <v-toolbar-side-icon v-if=\"leftSidebar && leftSidebar.visible && !leftSidebar.permanent\" class=\"header-icon\" @click=\"leftSidebar.open = !leftSidebar.open\"></v-toolbar-side-icon>\r\n    <!-- :style=\"{color:app.project.theme.colors.menu}\" -->\r\n    <img v-if=\"app.project.header.logo\" :src=\"app.project.header.logo\" class=\"app-project-logo\"></img>\r\n    <div class=\"header-title-container\" :style=\"{color:app.project.theme.colors.headerColor}\">\r\n      <v-breadcrumbs class=\"header-breadcrumbs\" v-if=\"app.project.header.breadcrumbs && !app.project.header.dense\">\r\n        <v-icon :style=\"{color:app.project.theme.colors.menu}\" slot=\"divider\">chevron_right</v-icon>\r\n        <v-breadcrumbs-item v-for=\"item in app.project.header.breadcrumbItems\" :key=\"item\">\r\n          {{ item}}\r\n        </v-breadcrumbs-item>\r\n      </v-breadcrumbs>\r\n      <v-toolbar-title class=\"header-title\" v-if=\"!app.project.navigation.hideTitle\">{{app.project.header.title}}</v-toolbar-title>\r\n    </div>\r\n\r\n    <!-- tabs -->\r\n\r\n    <v-tabs v-if=\"app.project.navigation.style==='tabs'\" color=\"primary\" class=\"cs-navigation-tabbar\">\r\n      <v-tab v-for=\"dashboard in app.project.dashboards\" @click=\"openDashboard(dashboard)\" :style=\"{color:app.project.theme.colors.headerColor}\" router :key=\"dashboard.id\" :to=\"{path:dashboard.path}\">\r\n        <v-menu v-if=\"dashboard.dashboards\" bottom open-on-hover>\r\n          <a slot=\"activator\" class=\"v-tabs__item\">\r\n            {{dashboard.title}}\r\n            <v-icon>arrow_drop_down</v-icon>\r\n          </a>\r\n\r\n          <v-list class=\"grey lighten-3\">\r\n            <v-list-tile v-for=\"subdash in dashboard.dashboards\" :key=\"subdash.id\" @click=\"openDashboard(subdash)\">\r\n              {{ subdash.title }}\r\n            </v-list-tile>\r\n          </v-list>\r\n        </v-menu>\r\n        <span :to=\"{path:dashboard.pathLink}\" v-else>\r\n          {{dashboard.title}}\r\n        </span>\r\n      </v-tab>\r\n\r\n\r\n\r\n    </v-tabs>\r\n    <v-spacer></v-spacer>\r\n\r\n    <!-- search -->\r\n\r\n    <v-text-field v-if=\"app.project.navigation.search && app.project.navigation.search.enabled\" prepend-icon=\"search\" hide-details\r\n      single-line></v-text-field>\r\n\r\n    <v-btn v-if=\"app.project.search\" icon>\r\n      <v-icon :style=\"{color:app.project.theme.colors.menu}\">search</v-icon>\r\n    </v-btn>\r\n\r\n    <!-- notifications -->\r\n\r\n    <v-menu v-if=\"app.project.header.showNotifications\" :close-on-content-click=\"false\" class=\"app-menu\" :nudge-width=\"200\" v-model=\"showNotifications\">\r\n      <v-badge slot=\"activator\" color=\"red\" overlap>\r\n        <span v-if=\"unReadNotifications.length>0\" slot=\"badge\">{{ unReadNotifications.length }}</span>\r\n        <v-icon :style=\"{color:app.project.theme.colors.menu}\">message</v-icon>\r\n      </v-badge>\r\n      <!-- <v-btn color=\"indigo\" dark >Menu as Popover</v-btn> -->\r\n      <v-card>\r\n        <v-toolbar-title>Notifications</v-toolbar-title>\r\n        <v-divider></v-divider>\r\n        <v-list two-line>\r\n          <template v-for=\"item in unReadNotifications\">\r\n            <v-list-tile avatar ripple @click=\"SelectNotification(item)\" :key=\"item.id\">\r\n              <v-list-tile-content>\r\n                <v-list-tile-title>{{ item.title }}</v-list-tile-title>\r\n                <v-list-tile-sub-title class=\"text--primary\">{{ item.text }}</v-list-tile-sub-title>\r\n              </v-list-tile-content>\r\n              <v-list-tile-action @click=\"item.isRead = true; UpdateNotifications()\">\r\n                <v-list-tile-action-text>{{ item.actionTitle }}</v-list-tile-action-text>\r\n                <v-icon color=\"yellow darken-2\">delete</v-icon>\r\n              </v-list-tile-action>\r\n            </v-list-tile>\r\n            <!-- <v-divider v-if=\"index + 1 < app.project.notifications.items.length\" :key=\"index\"></v-divider> -->\r\n          </template>\r\n        </v-list>\r\n        <v-card-actions>\r\n          <v-spacer></v-spacer>\r\n          <v-btn flat @click=\"showNotifications = false\">Close</v-btn>\r\n        </v-card-actions>\r\n      </v-card>\r\n    </v-menu>\r\n\r\n    <!-- menus -->\r\n\r\n    <v-menu v-for=\"menu in app.project.menus\" :key=\"menu.id\" :close-on-content-click=\"false\" v-if=\"menu.visible\" class=\"app-menu header-icon\"\r\n      offset-y >\r\n      <template v-if=\"menu.toggleButton\">\r\n        <v-tooltip slot=\"activator\" bottom>\r\n          <v-btn icon slot=\"activator\" v-model=\"menu.toggleState\" @click=\"toggleMenu(menu)\" :style=\"{color:app.project.theme.colors.headerColor}\">\r\n            <v-icon v-if=\"!menu.toggleState\">{{menu.icon}}</v-icon>\r\n            <v-icon v-else>{{menu.toggleIcon}}</v-icon>\r\n          </v-btn>\r\n          <template v-if=\"!menu.toggleState\">{{menu.toolTip}}</template>\r\n          <template v-else>{{menu.toggleToolTip}}</template>\r\n        </v-tooltip>\r\n      </template>\r\n      <template v-else>\r\n        <v-tooltip slot=\"activator\" bottom>\r\n          <v-btn icon slot=\"activator\" @click.delegate=\"activateMenu(menu)\" :style=\"{color:app.project.theme.colors.headerColor}\">\r\n            <v-icon>{{menu.icon}}</v-icon>\r\n          </v-btn>\r\n          {{menu.toolTip}}\r\n        </v-tooltip>\r\n      </template>\r\n\r\n      <v-list v-if=\"menu.items && menu.items.length>0\">\r\n        <v-list-tile v-for=\"menuItem in menu.items\" :key=\"menuItem.title\" v-if=\"menuItem.visible\" @click.delegate=\"activateMenu(menuItem)\">\r\n          <v-icon v-if=\"menuItem.icon\" :style=\"{color:app.project.theme.colors.menu}\">{{menuItem.icon}}</v-icon>\r\n          <v-list-tile-title>{{ menuItem.title }}</v-list-tile-title>\r\n        </v-list-tile>\r\n      </v-list>\r\n      <v-card v-if=\"menu.component\" style=\"z-index: 1000\">\r\n        <component :is=\"menu.component\" :data=\"menu.data\"></component>\r\n      </v-card>\r\n    </v-menu>\r\n\r\n    <!-- right side bar button -->\r\n\r\n    <v-btn v-if=\"rightSidebar && rightSidebar.visible && !rightSidebar.permanent\" @click=\"rightSidebar.open=!rightSidebar.open\"\r\n      class=\"header-icon\" icon>\r\n      <v-icon v-if=\"rightSidebar.open\">keyboard_arrow_right</v-icon>\r\n      <v-icon v-if=\"!rightSidebar.open\">keyboard_arrow_left</v-icon>\r\n    </v-btn>\r\n  </v-toolbar>\r\n\r\n  <!-- side bars -->\r\n\r\n  <cs-sidebar v-if=\"leftSidebar.visible\" class=\"sidebar\" :sideBar=\"leftSidebar\"></cs-sidebar>\r\n  <cs-sidebar v-if=\"rightSidebar.visible\" class=\"sidebar\" :sideBar=\"rightSidebar\"></cs-sidebar>\r\n\r\n  <!-- dialogs -->\r\n  <v-dialog v-model=\"dialog.visible\" :fullscreen=\"dialog.fullscreen\" hide-overlay transition=\"dialog-bottom-transition\">\r\n    <v-card tile>\r\n      <v-toolbar card color=\"primary\" v-if=\"dialog.toolbar\">\r\n        <v-btn icon @click.native=\"dialog.visible = false\">\r\n          <v-icon>close</v-icon>\r\n        </v-btn>\r\n        <v-toolbar-title>{{ dialog.title }}</v-toolbar-title>\r\n        <v-spacer></v-spacer>\r\n      </v-toolbar>\r\n      <v-card-text>\r\n        <component :is=\"dialog.component\"></component>\r\n      </v-card-text>\r\n      <div style=\"flex: 1 1 auto;\"></div>\r\n    </v-card>\r\n  </v-dialog>\r\n\r\n  <!-- content -->\r\n  <v-content fluid v-bind:class=\"{ 'floating': app.project.navigation.floating }\" v-touch=\"{left: () => swipe('Left'),right: () => swipe('Right')}\">\r\n    <router-view :key=\"$route.path\">\r\n    </router-view>\r\n  </v-content>\r\n\r\n  <!-- mobile navigation -->\r\n  <v-bottom-nav app router v-if=\"app.project.navigation.style==='bottom'\" :value=\"true\">\r\n    <v-btn v-for=\"dashboard in app.project.dashboards\" :key=\"dashboard.id\" color=\"teal\" flat :to=\"{path:dashboard.pathLink}\">\r\n      <span>{{dashboard.title}}</span>\r\n      <v-icon>{{dashboard.icon}}</v-icon>\r\n    </v-btn>\r\n  </v-bottom-nav>\r\n  <!-- footer -->\r\n  <cs-footer v-if=\"footer.visible\" :footer=\"footer\"></cs-footer>\r\n\r\n  <!-- snackbar -->\r\n  <v-snackbar :timeout=\"lastNotification.timeout\" :top=\"true\" :multi-line=\"true\" v-model=\"lastNotification._visible\">\r\n    {{ lastNotification.title }}\r\n    <v-btn flat @click.native=\"lastNotification._visible = false\">Close</v-btn>\r\n  </v-snackbar>\r\n\r\n</v-app>\r\n"

/***/ }),

/***/ "./src/components/cs-app/cs-app.ts":
/*!*****************************************!*\
  !*** ./src/components/cs-app/cs-app.ts ***!
  \*****************************************/
/*! exports provided: CsApp */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsApp", function() { return CsApp; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-router */ "../../node_modules/vue-router/dist/vue-router.esm.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var _cs_app_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cs-app.css */ "./src/components/cs-app/cs-app.css");
/* harmony import */ var _cs_app_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_cs_app_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _cs_sidebar_cs_sidebar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../cs-sidebar/cs-sidebar */ "./src/components/cs-sidebar/cs-sidebar.ts");
/* harmony import */ var _cs_footer_cs_footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../cs-footer/cs-footer */ "./src/components/cs-footer/cs-footer.ts");
/* harmony import */ var _assets_fonts_fonts_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../assets/fonts/fonts.css */ "./src/assets/fonts/fonts.css");
/* harmony import */ var _assets_fonts_fonts_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_assets_fonts_fonts_css__WEBPACK_IMPORTED_MODULE_8__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CsApp_1;









// register needed plugins'
// tslint:disable-next-line:no-console
vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(vue_router__WEBPACK_IMPORTED_MODULE_1__["default"]);
// Vue.component('cs-footer', CsFooter);
const router = new vue_router__WEBPACK_IMPORTED_MODULE_1__["default"]({ routes: [] });
let CsApp = CsApp_1 = class CsApp extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this.app = ___WEBPACK_IMPORTED_MODULE_4__["AppState"].Instance;
        this.settingsDialog = false;
        // public $vuetify: any;
        this.active = null;
        this.leftSidebar = {};
        this.rightSidebar = {};
        this.footer = {};
        this.dialog = { visible: false, toolbar: true };
        // notification properties
        this.lastNotification = { _visible: false };
        this.showNotifications = false;
        this.unReadNotifications = [];
        this.settings = [
        // {
        //   id: 'dashboard_settings',
        //   title: 'dashboard settings'
        // }
        ];
        this.app.router = router;
        this.InitNavigation();
        this.app.bus.subscribe('right-sidebar', (action, data) => {
            switch (action) {
                case 'open-widget':
                    if (this.app.project.rightSidebar &&
                        this.app.project.rightSidebar.dashboard &&
                        this.app.project.rightSidebar.dashboard.widgets) {
                        while (this.app.project.rightSidebar.dashboard.widgets.length > 0) {
                            this.app.project.rightSidebar.dashboard.widgets.pop();
                        }
                        this.app.project.rightSidebar.dashboard.widgets.push(data);
                        this.app.project.rightSidebar.open = true;
                    }
                    break;
            }
        });
        this.app.bus.subscribe('widget', (action, widget) => {
            switch (action) {
                case 'edit':
                    if (this.app.project.leftSidebar) {
                        this.app.project.leftSidebar.component = ___WEBPACK_IMPORTED_MODULE_4__["CsSettings"];
                        // this.$set(this.app.project.rightSidebar, 'component', CsSettings);
                        this.app.project.leftSidebar.open = true;
                    }
                    break;
            }
        });
    }
    projectChanged(data) {
        this.InitNavigation();
        this.InitTheme();
        this.InitMenus();
    }
    noticationsUpdated(n, o) {
        this.UpdateNotifications();
    }
    sideBarChanged(n, o) {
        if (!this.rightSidebar) {
            return;
        }
        this.rightSidebar.dashboard = n;
    }
    routeChanged(n, o) {
        if (this.app.project &&
            this.app.project.header &&
            this.app.project.header.breadcrumbs) {
            this.app.project.header.breadcrumbItems = [];
            n.fullPath.split('/').forEach(s => {
                if (s &&
                    this.app.project.header &&
                    this.app.project.header.breadcrumbItems) {
                    this.app.project.header.breadcrumbItems.push(s);
                }
            });
        }
    }
    openDashboard(dashboard) {
        if (dashboard) {
            if (dashboard.url) {
                // window.location.replace(dashboard.url);
                window.open(dashboard.url, '_blank');
            }
            else if (dashboard.path) {
                this.$router.push(dashboard.path);
            }
        }
    }
    InitMenus() {
        if (!this.app.project.menus) {
            this.app.project.menus = [];
        }
        // create edit dashboard button
        if (!this.app.project.menus.find(m => m.id === CsApp_1.DASHBOARD_EDIT_ID)) {
            this.app.project.menus.push({
                id: CsApp_1.DASHBOARD_EDIT_ID,
                icon: 'mode_edit',
                title: 'Edit Dashboard',
                enabled: false,
                visible: false,
                action: m => {
                    // notify dashboard manager that edit was started
                    if (this.app.activeDashboard) {
                        // if there is a manager with own editdashboard implementation use that
                        if (this.app.activeDashboard._manager &&
                            this.app.activeDashboard._manager.editDashboard) {
                            this.app.activeDashboard._manager.editDashboard(this.app.activeDashboard);
                        }
                        else {
                            if (this.app.project.rightSidebar) {
                                // let s = Vue.component('test', { template: '<h1>editor</h1>'});
                                // this.app.OpenRightSidebarWidget({component: MdWidget, data: 'editor'} as IWidget, { });
                                ___WEBPACK_IMPORTED_MODULE_4__["AppState"].Instance.OpenRightSidebarWidget({
                                    component: ___WEBPACK_IMPORTED_MODULE_4__["CsSettings"],
                                    data: { obj: this.app.activeDashboard.options }
                                });
                            }
                        }
                    }
                    // }
                }
            });
        }
    }
    toggleMenu(menu) {
        menu.toggleState = menu.toggleState ? !menu.toggleState : true;
        this.activateMenu(menu);
    }
    // menu button was clicked
    activateMenu(menu) {
        if (menu.action) {
            menu.action(menu);
        }
    }
    onResize() {
        this.app.windowSize = { x: window.innerWidth, y: window.innerHeight };
    }
    InitTheme() {
        if (this.app.project && this.app.project.theme) {
            this.$vuetify.theme = this.app.project.theme.colors;
        }
    }
    getAdjacentDashboard(direction, active, dashboards) {
        if (!dashboards) {
            return active;
        }
        let index = dashboards.indexOf(active);
        switch (direction) {
            case 'Left':
                index += 1;
                if (index >= dashboards.length) {
                    index = 0;
                }
                break;
            case 'Right':
                index -= 1;
                if (index < 0) {
                    index = dashboards.length - 1;
                }
                break;
        }
        return dashboards[index];
    }
    // swipe gesture
    swipe(direction) {
        if (!this.app.activeDashboard ||
            !this.app.activeDashboard.options ||
            !this.app.activeDashboard.options.TouchGesturesEnabled) {
            return;
        }
        const d = this.app.activeDashboard;
        const adjacent = this.getAdjacentDashboard(direction, this.app.activeDashboard, d.parent && d.parent.dashboards
            ? d.parent.dashboards
            : this.app.project.dashboards);
        if (adjacent) {
            this.SelectDashboard(adjacent);
        }
        // console.log(adjacent);
    }
    // Add a dashboard as a route
    AddDashboardRoute(d) {
        if (d.dashboards && d.dashboards.length > 0) {
            d.dashboards.forEach(dash => {
                dash.parent = d;
                this.AddDashboardRoute(dash);
            });
        }
        else if (d.path) {
            router.addRoutes([
                {
                    name: d.id,
                    path: d.path,
                    component: ___WEBPACK_IMPORTED_MODULE_4__["CsDashboard"],
                    props: route => ({ dashboard: d }),
                    alias: d.title,
                    meta: d
                }
            ]);
        }
    }
    // Make sure all dashboards are available as routes
    InitNavigation() {
        if (!this.app || !this.app.project || !this.app.project.dashboards) {
            return;
        }
        // create routes for dashboards
        this.app.project.dashboards.forEach(d => {
            this.AddDashboardRoute(d);
        });
        ___WEBPACK_IMPORTED_MODULE_4__["Logger"].info('navigation', 'navigation initialized');
    }
    // tslint:disable-next-line:no-empty
    selectBreadCrumb(item) { }
    SelectDashboard(d) {
        ___WEBPACK_IMPORTED_MODULE_4__["Logger"].info('SelectDashboard', d.path);
        if (router && d.path && !d.dashboards) {
            router.push(d.path);
        }
    }
    OpenSettings() {
        this.settingsDialog = true;
    }
    UpdateSideBars(d) {
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(() => {
            // update left sidebar
            if (d.leftSidebar) {
                this.leftSidebar = d.leftSidebar;
                this.leftSidebar.visible = true;
                // Vue.set(this, 'leftSidebar', d.leftSidebar);
            }
            else if (this.app.project.leftSidebar) {
                this.leftSidebar = this.app.project.leftSidebar;
                this.leftSidebar.visible = true;
                // Vue.set(this, 'leftSidebar', this.app.project.leftSidebar);
            }
            else {
                this.leftSidebar = {};
            }
            if (d.rightSidebar) {
                this.rightSidebar = d.rightSidebar;
                this.rightSidebar.visible = true;
                this.rightSidebar.right = true;
                // Vue.set(this, 'rightSidebar', d.rightSidebar);
            }
            else if (this.app.project.rightSidebar) {
                this.rightSidebar = this.app.project.rightSidebar;
                this.rightSidebar.visible = true;
                this.rightSidebar.right = true;
                // Vue.set(this, 'rightSidebar', this.app.project.rightSidebar);
            }
            else {
                this.rightSidebar = {};
            }
        });
    }
    UpdateFooter(d) {
        if (d.footer) {
            this.footer = d.footer;
            this.footer.visible = true;
            // Vue.set(this, 'rightSidebar', d.rightSidebar);
        }
        else if (this.app.project.footer) {
            this.footer = this.app.project.footer;
            // Vue.set(this, 'rightSidebar', this.app.project.rightSidebar);
        }
        else {
            this.footer = {};
        }
    }
    created() {
        this.onResize();
        this.InitNotifications();
        this.app.bus.subscribe('dialog', (action, dialog) => {
            switch (action) {
                case 'new':
                    vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(this, 'dialog', dialog);
                    this.dialog.visible = true;
                    break;
            }
        });
        // listen to dashboard init events
        this.app.bus.subscribe('dashboard.main', (action, dashboard) => {
            this.UpdateSideBars(dashboard);
            this.UpdateFooter(dashboard);
        });
        if (this.app.activeDashboard) {
            this.UpdateSideBars(this.app.activeDashboard);
            this.UpdateFooter(this.app.activeDashboard);
        }
    }
    SelectNotification(notification) {
        notification.isRead = true;
        this.UpdateNotifications();
        if (notification.clickCallback) {
            notification.clickCallback();
        }
    }
    /** Update list of unread notification  */
    UpdateNotifications() {
        if (!this.app.project.notifications ||
            !this.app.project.notifications.items) {
            return;
        }
        this.$set(this, 'unReadNotifications', this.app.project.notifications.items.filter(not => !not.isRead));
    }
    InitNotifications() {
        if (this.app.bus) {
            this.app.bus.subscribe('notification', (action, notification) => {
                if (action === 'new') {
                    this.lastNotification = notification;
                    this.UpdateNotifications();
                }
            });
        }
    }
};
CsApp.DASHBOARD_EDIT_ID = 'edit_dashboard';
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('app.project.dashboards'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CsApp.prototype, "projectChanged", null);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('app.project.notifications', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", void 0)
], CsApp.prototype, "noticationsUpdated", null);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('app.project.rightSidebar.dashboard'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CsApp.prototype, "sideBarChanged", null);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CsApp.prototype, "routeChanged", null);
CsApp = CsApp_1 = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
        name: 'cs-app',
        router,
        template: __webpack_require__(/*! ./cs-app.html */ "./src/components/cs-app/cs-app.html"),
        components: {
            'cs-sidebar': _cs_sidebar_cs_sidebar__WEBPACK_IMPORTED_MODULE_6__["CsSidebar"],
            'cs-footer': _cs_footer_cs_footer__WEBPACK_IMPORTED_MODULE_7__["CsFooter"]
        }
    }),
    __metadata("design:paramtypes", [])
], CsApp);



/***/ }),

/***/ "./src/components/cs-dashboard/cs-dashboard.html":
/*!*******************************************************!*\
  !*** ./src/components/cs-dashboard/cs-dashboard.html ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<component :is=\"component\" :dashboard=\"dashboard\"></component>\n"

/***/ }),

/***/ "./src/components/cs-dashboard/cs-dashboard.ts":
/*!*****************************************************!*\
  !*** ./src/components/cs-dashboard/cs-dashboard.ts ***!
  \*****************************************************/
/*! exports provided: CsDashboard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsDashboard", function() { return CsDashboard; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let CsDashboard = class CsDashboard extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.app = ___WEBPACK_IMPORTED_MODULE_4__["AppState"].Instance;
    }
    dashboardChanged(n, o) {
        this.initDashboard(n);
    }
    widgetsChanged(n, old) {
        if (n && n.length > 0) {
            n.forEach(w => {
                this.initWidget(w);
            });
        }
    }
    checkWidgetId(widget) {
        if (widget && !widget.id) {
            widget.id = 'widget-' + Object(___WEBPACK_IMPORTED_MODULE_4__["guidGenerator"])();
        }
    }
    initWidget(widget) {
        // init widget
        if (!widget) {
            return;
        }
        if (widget._initalized) {
            return;
        }
        if (!widget.events) {
            widget.events = new _csnext_cs_core__WEBPACK_IMPORTED_MODULE_3__["MessageBusService"]();
        }
        if (!widget.options) {
            widget.options = {};
        }
        if (!widget.data) {
            widget.data = {};
        }
        if (this.dashboard) {
            widget._dashboard = this.dashboard;
        }
        widget._project = ___WEBPACK_IMPORTED_MODULE_4__["AppState"].Instance.project;
        this.checkWidgetId(widget);
        this.checkDefaultWidgetOptions(widget);
        // load datasource, if configured
        if (widget.datasource !== undefined) {
            this.app.loadDatasource(widget.datasource).then(d => {
                this.$nextTick(() => {
                    vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(widget, 'content', d);
                });
            });
        }
        else if (this.dashboard && this.dashboard.content) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(widget, 'content', this.dashboard.content);
        }
        widget._initalized = true;
    }
    /** init dashboard: load datasources, init widgets and init manager  */
    initDashboard(dashboard) {
        if (!dashboard.events) {
            dashboard.events = new _csnext_cs_core__WEBPACK_IMPORTED_MODULE_3__["MessageBusService"]();
        }
        if (dashboard.hideFromNavigation === undefined) {
            dashboard.hideFromNavigation = false;
        }
        if (!dashboard.options) {
            dashboard.options = {};
        }
        if (this.app.project.menus && dashboard.isMain) {
            const dashboardEditButton = this.app.project.menus.find(mi => mi.id === ___WEBPACK_IMPORTED_MODULE_4__["CsApp"].DASHBOARD_EDIT_ID);
            if (dashboardEditButton) {
                dashboardEditButton.visible =
                    dashboardEditButton && dashboard.options.EditButton;
            }
        }
        // if this is a main dashboard, set it as active dashboard on appstate
        if (dashboard.isMain) {
            this.app.activeDashboard = this.dashboard;
            this.app.bus.publish('dashboard.main', 'init', this.dashboard);
        }
        // init widgets
        if (this.dashboard && this.dashboard.widgets) {
            this.dashboard.widgets.forEach(w => {
                this.initWidget(w);
            });
        }
        // init dashboard manager
        if (dashboard.manager && !dashboard._manager) {
            if (___WEBPACK_IMPORTED_MODULE_4__["DashboardManager"].dashboardManagers.hasOwnProperty(dashboard.manager)) {
                // instantiate manager
                dashboard._manager = ___WEBPACK_IMPORTED_MODULE_4__["DashboardManager"].dashboardManagers[dashboard.manager].getInstance();
                if (dashboard._manager) {
                    // start manager
                    dashboard._manager.start(dashboard);
                }
            }
        }
        if (dashboard._manager && dashboard._manager.dashboardLoaded) {
            dashboard._manager.dashboardLoaded(dashboard);
        }
        // load default datasource, if configured
        if (dashboard.datasource) {
            this.app
                .loadDatasource(dashboard.datasource)
                .catch(e => {
                if (!this.dashboard) {
                    return;
                }
                ___WEBPACK_IMPORTED_MODULE_4__["Logger"].error('dashboard datasource', 'error loading datasource ' + this.dashboard.datasource);
            })
                .then(d => {
                if (!this.dashboard) {
                    return;
                }
                this.dashboard.content = d;
                // if there are widgets without dashboards, use dashboard content, note: only works for widgets that are initially defined
                if (this.dashboard.widgets) {
                    this.dashboard.widgets.forEach(w => {
                        if (!w.datasource && this.dashboard && this.dashboard.content) {
                            vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(w, 'content', this.dashboard.content);
                        }
                    });
                }
                // if dashboard manager availabe, trigger data loaded event
                if (this.dashboard._manager && this.dashboard._manager.dataLoaded) {
                    this.dashboard._manager.dataLoaded(d);
                }
            });
        }
    }
    created() {
        if (!this.dashboard) {
            return;
        }
        this.initDashboard(this.dashboard);
    }
    /** dashboard will be closed. */
    beforeDestroy() {
        // call stop function for manager
        if (this.dashboard && this.dashboard._manager) {
            this.dashboard._manager.stop(this.dashboard);
        }
    }
    get component() {
        if (this.dashboard) {
            // use default single layout, if no layout has been specified
            if (!this.dashboard.layout) {
                this.dashboard.layout = 'grid';
            }
            // lookup layout manager
            if (___WEBPACK_IMPORTED_MODULE_4__["LayoutManager"].layoutManagers.hasOwnProperty(this.dashboard.layout)) {
                return ___WEBPACK_IMPORTED_MODULE_4__["LayoutManager"].layoutManagers[this.dashboard.layout].component;
            }
        }
        return new vue__WEBPACK_IMPORTED_MODULE_0___default.a();
    }
    checkDefaultWidgetOptions(widget) {
        if (!widget.options ||
            !widget._dashboard ||
            !widget._dashboard.defaultWidgetOptions) {
            return;
        }
        if (widget._dashboard && widget._dashboard.defaultWidgetOptions) {
            for (const key in widget._dashboard.defaultWidgetOptions) {
                if (!widget.options.hasOwnProperty(key)) {
                    widget.options[key] = widget._dashboard.defaultWidgetOptions[key];
                }
            }
        }
    }
};
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('dashboard'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CsDashboard.prototype, "dashboardChanged", null);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('dashboard.widgets', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Object]),
    __metadata("design:returntype", void 0)
], CsDashboard.prototype, "widgetsChanged", null);
CsDashboard = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-dashboard',
        template: __webpack_require__(/*! ./cs-dashboard.html */ "./src/components/cs-dashboard/cs-dashboard.html"),
        props: {
            dashboard: null
        }
    })
], CsDashboard);



/***/ }),

/***/ "./src/components/cs-footer/cs-footer.css":
/*!************************************************!*\
  !*** ./src/components/cs-footer/cs-footer.css ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./cs-footer.css */ "../../node_modules/css-loader/index.js!./src/components/cs-footer/cs-footer.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/components/cs-footer/cs-footer.html":
/*!*************************************************!*\
  !*** ./src/components/cs-footer/cs-footer.html ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<v-footer height=\"auto\" fixed class=\"footer-class\">\n  <cs-dashboard v-if=\"footer.dashboard\" :dashboard=\"footer.dashboard\"></cs-dashboard>\n</v-footer>\n"

/***/ }),

/***/ "./src/components/cs-footer/cs-footer.ts":
/*!***********************************************!*\
  !*** ./src/components/cs-footer/cs-footer.ts ***!
  \***********************************************/
/*! exports provided: CsFooter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsFooter", function() { return CsFooter; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var _cs_footer_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cs-footer.css */ "./src/components/cs-footer/cs-footer.css");
/* harmony import */ var _cs_footer_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cs_footer_css__WEBPACK_IMPORTED_MODULE_4__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let CsFooter = class CsFooter extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.app = ___WEBPACK_IMPORTED_MODULE_3__["AppState"].Instance;
    }
    footerChanged(n, o) {
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(() => {
            if (this.footer) {
                if (this.footer.dashboard && this.footer.dashboard.widgets) {
                    this.footer.dashboard.widgets[0] = n.widgets[0];
                }
                if (!this.footer.width) {
                    this.footer.width = 300;
                }
            }
            this.$forceUpdate();
        });
    }
};
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])(),
    __metadata("design:type", Object)
], CsFooter.prototype, "footer", void 0);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('footer.dashboard'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CsFooter.prototype, "footerChanged", null);
CsFooter = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-footer',
        template: __webpack_require__(/*! ./cs-footer.html */ "./src/components/cs-footer/cs-footer.html")
    })
], CsFooter);



/***/ }),

/***/ "./src/components/cs-settings/cs-settings.html":
/*!*****************************************************!*\
  !*** ./src/components/cs-settings/cs-settings.html ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<v-container>\r\n  <h1>{{ Form.title }}</h1>\r\n  <v-form>\r\n    <v-layout row wrap v-for=\"group in fieldGroups\" dense>\r\n      <v-flex :class=\"group.class\" v-for=\"field in group.fields\" :key=\"field.id\" style=\"padding-right:2px\" dense>\r\n        <v-tooltip bottom :disabled=\"!field.description\">\r\n          <template slot=\"activator\">\r\n            <template v-if=\"field.type === 'boolean'\">\r\n              <v-checkbox v-model=\"Target[field._key]\" :label=\"field.title\" :required=\"field.required\"></v-checkbox>\r\n            </template>\r\n            <template v-if=\"field.type === 'string'\">\r\n              <v-text-field v-model=\"Target[field._key]\" :label=\"field.title\" :required=\"field.required\"></v-text-field>\r\n            </template>\r\n            <template v-if=\"field.type === 'number'\">\r\n              <v-text-field v-model=\"Target[field._key]\" type=\"number\" :label=\"field.title\" :required=\"field.required\"></v-text-field>\r\n            </template>\r\n          </template>\r\n          {{field.description}}\r\n        </v-tooltip>\r\n\r\n        <!-- {{ field.title }} -->\r\n      </v-flex>\r\n    </v-layout>\r\n  </v-form>\r\n\r\n</v-container>\r\n"

/***/ }),

/***/ "./src/components/cs-settings/cs-settings.ts":
/*!***************************************************!*\
  !*** ./src/components/cs-settings/cs-settings.ts ***!
  \***************************************************/
/*! exports provided: FieldGroup, CsSettings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldGroup", function() { return FieldGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsSettings", function() { return CsSettings; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! reflect-metadata */ "../../node_modules/reflect-metadata/Reflect.js");
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(reflect_metadata__WEBPACK_IMPORTED_MODULE_4__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





class FieldGroup {
    constructor() {
        this.fields = [];
        this.class = '';
    }
}
// tslint:disable-next-line:max-classes-per-file
let CsSettings = class CsSettings extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    // tslint:disable-next-line:max-classes-per-file
    constructor() {
        super(...arguments);
        this.app = ___WEBPACK_IMPORTED_MODULE_2__["AppState"].Instance;
        this.L = ___WEBPACK_IMPORTED_MODULE_2__["Logger"].Instance;
        this.fieldGroups = [];
    }
    initGroups() {
        this.fieldGroups = [];
        if (!this.Form.fields) {
            return;
        }
        this.Form.fields.map(f => {
            if (!f.group) {
                const newGroup = new FieldGroup();
                newGroup.id = f._key + '-group';
                newGroup.fields.push(f);
                this.fieldGroups.push(newGroup);
            }
            else {
                const group = this.fieldGroups.find(field => f.group === field.id);
                if (group) {
                    group.fields.push(f);
                }
                else {
                    const newGroup = new FieldGroup();
                    newGroup.id = f.group;
                    newGroup.fields.push(f);
                    this.fieldGroups.push(newGroup);
                }
            }
        });
        this.fieldGroups.map(fg => {
            switch (fg.fields.length) {
                case 1:
                    fg.class = 'md12';
                    break;
                case 2:
                    fg.class = 'md6';
                    break;
                case 3:
                    fg.class = 'md4';
                    break;
                case 4:
                    fg.class = 'md3';
                    break;
            }
        });
    }
    get Target() {
        return this.Widget.data.obj;
    }
    get Form() {
        return this.Widget.data.obj._form;
    }
    get Widget() {
        return this.$parent.widget;
    }
    dataChanged(d) {
        // console.log('Widget changed');
    }
    created() {
        this.initGroups();
    }
};
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('widget'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CsSettings.prototype, "dataChanged", null);
CsSettings = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-settings',
        template: __webpack_require__(/*! ./cs-settings.html */ "./src/components/cs-settings/cs-settings.html"),
        components: {}
    })
], CsSettings);



/***/ }),

/***/ "./src/components/cs-sidebar/cs-sidebar.css":
/*!**************************************************!*\
  !*** ./src/components/cs-sidebar/cs-sidebar.css ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./cs-sidebar.css */ "../../node_modules/css-loader/index.js!./src/components/cs-sidebar/cs-sidebar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/components/cs-sidebar/cs-sidebar.html":
/*!***************************************************!*\
  !*** ./src/components/cs-sidebar/cs-sidebar.html ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<v-navigation-drawer :width=\"sideBar.width\" disable-route-watcher v-if=\"sideBar\" v-model=\"sideBar.open\" :right=\"sideBar.right\" :mini-variant=\"sideBar.mini\"\n  :clipped=\"sideBar.clipped\" :permanent=\"sideBar.permanent\" :persistent=\"sideBar.persistent\" :temporary=\"sideBar.temporary\"\n  :floating=\"sideBar.floating\" absolute overflow app>\n\n  <v-toolbar v-if=\"sideBar.title\">\n    <v-list dense>\n      <v-list-tile>\n        <v-icon v-if=\"app.project.navigation.icons\">home</v-icon>\n        <v-list-tile-title class=\"title\">{{sideBar.title}}</v-list-tile-title>\n      </v-list-tile>\n    </v-list>\n  </v-toolbar>\n  <div v-if=\"sideBar.canPin\" class=\"leftsidebar-pin\">\n    <v-btn small icon @click=\"sideBar.temporary=!sideBar.temporary\">\n      <v-icon small v-if=\"sideBar.temporary\">lock_open</v-icon>\n      <v-icon small v-if=\"!sideBar.temporary\">lock_outline</v-icon>\n    </v-btn>\n  </div>\n\n  <div v-if=\"sideBar.canMinifiy\" class=\"leftsidebar-minify\">\n    <v-btn small icon @click=\"sideBar.mini=!sideBar.mini\">\n      <v-icon small v-if=\"sideBar.mini\">keyboard_arrow_right</v-icon>\n      <v-icon small v-if=\"!sideBar.mini\">keyboard_arrow_left</v-icon>\n    </v-btn>\n  </div>\n\n  <v-divider v-if=\"sideBar.title\"></v-divider>\n  <div v-if=\"sideBar.component\">\n    <component :is=\"sideBar.component\"></component>\n  </div>\n  <div v-if=\"sideBar.dashboard\">\n    <cs-dashboard :dashboard=\"sideBar.dashboard\"></cs-dashboard>\n  </div>\n  <div v-else-if=\"app.project.navigation.style==='left' && !sideBar.right\">\n    <v-list>\n      <v-list-tile v-for=\"item in app.project.dashboards\" :value=\"item.active\" :to=\"item.path\" no-action v-bind:key=\"item.path\">\n        <v-list-tile-action>\n          <v-icon>{{ item.icon }}</v-icon>\n        </v-list-tile-action>\n        <v-list-tile-content >\n          <v-list-tile-title>{{ item.title }}</v-list-tile-title>\n        </v-list-tile-content>\n      </v-list-tile>\n    </v-list>\n  </div>\n  <div v-else-if=\"app.project.navigation.style==='left-hierarchy' && !sideBar.right\">\n    <v-list>\n      <v-list-group v-for=\"item in app.project.dashboards\" :value=\"item.active\" v-show=\"!item.hideFromNavigation\" no-action v-bind:key=\"item.path\" :append-icon=\"item.dashboards ? undefined : ''\" >\n        <v-list-tile slot=\"activator\">\n          <v-list-tile-action>\n            <v-icon>{{ item.icon }}</v-icon>\n          </v-list-tile-action>\n          <v-list-tile-content>\n            <v-list-tile-title @click=\"SelectDashboard(item)\">{{ item.title }}</v-list-tile-title>\n          </v-list-tile-content>\n        </v-list-tile>\n        <v-list-tile v-if=\"!sideBar.mini\" v-for=\"subItem in item.dashboards\" :to=\"subItem.path\" v-show=\"!subItem.hideFromNavigation\" v-bind:key=\"subItem.path\">\n            <!-- @click=\"SelectDashboard(subItem)\" -->\n          <v-list-tile-content>\n            <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>\n          </v-list-tile-content>\n          <v-list-tile-action>\n            <v-icon>{{ subItem.action }}</v-icon>\n          </v-list-tile-action>\n        </v-list-tile>\n      </v-list-group>\n    </v-list>\n  </div>\n</v-navigation-drawer>\n"

/***/ }),

/***/ "./src/components/cs-sidebar/cs-sidebar.ts":
/*!*************************************************!*\
  !*** ./src/components/cs-sidebar/cs-sidebar.ts ***!
  \*************************************************/
/*! exports provided: CsSidebar */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsSidebar", function() { return CsSidebar; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var _cs_sidebar_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cs-sidebar.css */ "./src/components/cs-sidebar/cs-sidebar.css");
/* harmony import */ var _cs_sidebar_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cs_sidebar_css__WEBPACK_IMPORTED_MODULE_4__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let CsSidebar = class CsSidebar extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.app = ___WEBPACK_IMPORTED_MODULE_3__["AppState"].Instance;
    }
    sideBarChanged(n, o) {
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(() => {
            if (this.sideBar) {
                if (this.sideBar.dashboard && this.sideBar.dashboard.widgets) {
                    this.sideBar.dashboard.widgets[0] = n.widgets[0];
                }
                if (!this.sideBar.width) {
                    this.sideBar.width = 300;
                }
            }
            this.$forceUpdate();
        });
    }
    SelectDashboard(d) {
        ___WEBPACK_IMPORTED_MODULE_3__["Logger"].info('SelectDashboard', d.path);
        if (this.$router && d.path && !d.dashboards) {
            this.$router.push(d.path);
        }
    }
};
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])(),
    __metadata("design:type", Object)
], CsSidebar.prototype, "sideBar", void 0);
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('sideBar.dashboard'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CsSidebar.prototype, "sideBarChanged", null);
CsSidebar = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-sidebar',
        template: __webpack_require__(/*! ./cs-sidebar.html */ "./src/components/cs-sidebar/cs-sidebar.html")
    })
], CsSidebar);



/***/ }),

/***/ "./src/components/cs-widget/cs-widget.css":
/*!************************************************!*\
  !*** ./src/components/cs-widget/cs-widget.css ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./cs-widget.css */ "../../node_modules/css-loader/index.js!./src/components/cs-widget/cs-widget.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/components/cs-widget/cs-widget.html":
/*!*************************************************!*\
  !*** ./src/components/cs-widget/cs-widget.html ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div @mouseenter=\"mouseEnter()\" v-if=\"widget\" @mouseleave=\"mouseLeave()\" :class=\"[widget.options.class, widgetBorder]\" ref=\"widget\" v-resize:debounce.50=\"onResize\" >\r\n  <component :is=\"widget.component\" :widget=\"widget\" class=\"widget-default\" :style=\"widgetStyles()\" ></component>\r\n  <div v-if=\"mouseOver && widget.options.menus\" class=\"widget-buttons-container\">\r\n    <v-menu v-for=\"menu in widget.options.menus\" :key=\"menu.id\" v-if=\"menu.visible\">\r\n      <v-btn icon slot=\"activator\" @click.delegate=\"triggerMenuAction(menu)\" flat icon class=\"widget-button\">\r\n        <v-icon size=\"16px\">{{menu.icon}}</v-icon>\r\n      </v-btn>\r\n    </v-menu>   \r\n  </div>\r\n</div>\r\n"

/***/ }),

/***/ "./src/components/cs-widget/cs-widget.ts":
/*!***********************************************!*\
  !*** ./src/components/cs-widget/cs-widget.ts ***!
  \***********************************************/
/*! exports provided: CsWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsWidget", function() { return CsWidget; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_resize_directive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-resize-directive */ "../../node_modules/vue-resize-directive/dist/Vueresize.js");
/* harmony import */ var vue_resize_directive__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_resize_directive__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cs_widget_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cs-widget.css */ "./src/components/cs-widget/cs-widget.css");
/* harmony import */ var _cs_widget_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cs_widget_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let CsWidget = class CsWidget extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.mouseOver = false;
        this.app = ___WEBPACK_IMPORTED_MODULE_5__["AppState"].Instance;
    }
    updateSize() {
        if (!this.widget || !this.widget.events) {
            return;
        }
        if (this.$refs.widget) {
            this.widget._size = {
                width: this.$refs.widget.clientWidth,
                height: this.$refs.widget.clientHeight
            };
        }
        this.widget.events.publish('resize', 'changed', this.widget._size);
    }
    onResize() {
        this.updateSize();
    }
    get widgetBorder() {
        if (!this.widget) {
            return;
        }
        if (this.widget.options && this.widget.options.widgetBorder) {
            return this.widget.options.widgetBorder;
        }
        else if (this.widget._dashboard &&
            this.widget._dashboard.defaultWidgetOptions &&
            this.widget._dashboard.defaultWidgetOptions.widgetBorder) {
            return this.widget._dashboard.defaultWidgetOptions.widgetBorder;
        }
    }
    widgetStyles() {
        const res = {};
        if (this.widget &&
            this.widget._dashboard &&
            this.widget._dashboard.defaultWidgetOptions) {
            const opt = this.widget._dashboard.defaultWidgetOptions;
            if (opt.height) {
                res['max-height'] = opt.height + 'px';
            }
        }
        return res;
    }
    addMenuItem(menu) {
        if (!this.widget || !this.widget.options) {
            return;
        }
        if (this.widget && !this.widget.events) {
            this.widget.events = new _csnext_cs_core__WEBPACK_IMPORTED_MODULE_2__["MessageBusService"]();
        }
        if (!this.widget.options.menus) {
            this.widget.options.menus = [];
        }
        if (!this.widget.options.menus.find(m => m.id === menu.id)) {
            this.widget.options.menus.push(menu);
        }
    }
    created() {
        if (!this.widget || !this.widget.options) {
            return;
        }
        if (this.widget.options.canEdit) {
            this.addMenuItem({
                id: 'edit',
                icon: 'mode_edit',
                title: 'edit',
                visible: true,
                action: () => {
                    if (this.widget &&
                        this.widget.editorWidget &&
                        this.app.project.rightSidebar) {
                        const editor = this.widget.editorWidget;
                        editor.data = {
                            data: this.widget.data,
                            widget: this.widget,
                            widgetoptions: this.widget.options,
                            manager: this.widget._dashboard && this.widget._dashboard._manager
                                ? this.widget._dashboard._manager
                                : null
                        };
                        this.app.bus.publish('right-sidebar', 'open-widget', editor);
                    }
                }
            });
        }
        if (this.widget.options.canRemove) {
            this.addMenuItem({
                id: 'remove',
                icon: 'delete',
                title: 'remove',
                visible: true,
                action: () => {
                    if (this.widget && this.widget._dashboard) {
                        if (this.widget._dashboard._manager &&
                            this.widget._dashboard._manager.removeWidget) {
                            this.widget._dashboard._manager.removeWidget(this.widget);
                        }
                    }
                }
            });
        }
    }
    triggerMenuAction(menu) {
        if (menu.action) {
            menu.action(menu);
        }
    }
    mouseEnter() {
        this.mouseOver = true;
    }
    mouseLeave() {
        this.mouseOver = false;
    }
};
CsWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-widget',
        template: __webpack_require__(/*! ./cs-widget.html */ "./src/components/cs-widget/cs-widget.html"),
        directives: { resize: (vue_resize_directive__WEBPACK_IMPORTED_MODULE_3___default()) },
        props: {
            widget: null
        }
    })
], CsWidget);



/***/ }),

/***/ "./src/datasources/webrequest-datasource.ts":
/*!**************************************************!*\
  !*** ./src/datasources/webrequest-datasource.ts ***!
  \**************************************************/
/*! exports provided: WebRequestDatasourceProcessor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebRequestDatasourceProcessor", function() { return WebRequestDatasourceProcessor; });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ */ "./src/index.ts");


class WebRequestDatasourceProcessor {
    constructor() {
        this.id = 'webrequest';
    }
    execute(sources, ds) {
        return new Promise((resolve, reject) => {
            if (ds.source === undefined) {
                return reject('No source defined');
            }
            axios__WEBPACK_IMPORTED_MODULE_0___default.a.get(ds.source)
                .catch(e => { reject(e); })
                .then(response => {
                if (response) {
                    resolve(response.data);
                }
            });
        });
    }
}
___WEBPACK_IMPORTED_MODULE_1__["DatasourceManager"].add(new WebRequestDatasourceProcessor());


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! exports provided: guidGenerator, idGenerator, FlexWidgetOptions, csnext, AppState, Logger, ProjectManager, DatasourceManager, DashboardManager, LayoutManager, Single, Grid, CssGrid, FlexGrid, FlexSize, FlexGridOptions, SplitPanel, SplitWidgetOptions, WebRequestDatasourceProcessor, CsApp, CsWidget, CsDashboard, FieldGroup, CsSettings, WidgetBase, MdWidget, IMdWidgetOptions, IframeWidget, YoutubeBackgroundWidget, ImageWidget, SvgWidget, VegaWidget, CsIntroWidget, IntroWidgetOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "csnext", function() { return csnext; });
/* harmony import */ var _services_app_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./services/app-state */ "./src/services/app-state.ts");
/* harmony import */ var _utils_guid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/guid */ "./src/utils/guid.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "guidGenerator", function() { return _utils_guid__WEBPACK_IMPORTED_MODULE_1__["guidGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "idGenerator", function() { return _utils_guid__WEBPACK_IMPORTED_MODULE_1__["idGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AppState", function() { return _services_app_state__WEBPACK_IMPORTED_MODULE_0__["AppState"]; });

/* harmony import */ var _services_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./services/logger */ "./src/services/logger.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return _services_logger__WEBPACK_IMPORTED_MODULE_2__["Logger"]; });

/* harmony import */ var _services_project_manager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./services/project-manager */ "./src/services/project-manager.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectManager", function() { return _services_project_manager__WEBPACK_IMPORTED_MODULE_3__["ProjectManager"]; });

/* harmony import */ var _services_datasource_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./services/datasource-manager */ "./src/services/datasource-manager.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatasourceManager", function() { return _services_datasource_manager__WEBPACK_IMPORTED_MODULE_4__["DatasourceManager"]; });

/* harmony import */ var _services_dashboard_manager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./services/dashboard-manager */ "./src/services/dashboard-manager.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DashboardManager", function() { return _services_dashboard_manager__WEBPACK_IMPORTED_MODULE_5__["DashboardManager"]; });

/* harmony import */ var _services_layout_manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./services/layout-manager */ "./src/services/layout-manager.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LayoutManager", function() { return _services_layout_manager__WEBPACK_IMPORTED_MODULE_6__["LayoutManager"]; });

/* harmony import */ var _layout_single_single__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./layout/single/single */ "./src/layout/single/single.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Single", function() { return _layout_single_single__WEBPACK_IMPORTED_MODULE_7__["Single"]; });

/* harmony import */ var _layout_grid_grid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./layout/grid/grid */ "./src/layout/grid/grid.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _layout_grid_grid__WEBPACK_IMPORTED_MODULE_8__["Grid"]; });

/* harmony import */ var _layout_css_grid_css_grid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./layout/css-grid/css-grid */ "./src/layout/css-grid/css-grid.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CssGrid", function() { return _layout_css_grid_css_grid__WEBPACK_IMPORTED_MODULE_9__["CssGrid"]; });

/* harmony import */ var _layout_flex_grid_flex_grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./layout/flex-grid/flex-grid */ "./src/layout/flex-grid/flex-grid.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexGrid", function() { return _layout_flex_grid_flex_grid__WEBPACK_IMPORTED_MODULE_10__["FlexGrid"]; });

/* harmony import */ var _layout_flex_grid_flex_size__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./layout/flex-grid/flex-size */ "./src/layout/flex-grid/flex-size.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexSize", function() { return _layout_flex_grid_flex_size__WEBPACK_IMPORTED_MODULE_11__["FlexSize"]; });

/* harmony import */ var _layout_flex_grid_flex_grid_options__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./layout/flex-grid/flex-grid-options */ "./src/layout/flex-grid/flex-grid-options.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexGridOptions", function() { return _layout_flex_grid_flex_grid_options__WEBPACK_IMPORTED_MODULE_12__["FlexGridOptions"]; });

/* harmony import */ var _layout_flex_grid_flex_widget_options__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./layout/flex-grid/flex-widget-options */ "./src/layout/flex-grid/flex-widget-options.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexWidgetOptions", function() { return _layout_flex_grid_flex_widget_options__WEBPACK_IMPORTED_MODULE_13__["FlexWidgetOptions"]; });

/* harmony import */ var _layout_split_panel_split_panel__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./layout/split-panel/split-panel */ "./src/layout/split-panel/split-panel.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SplitPanel", function() { return _layout_split_panel_split_panel__WEBPACK_IMPORTED_MODULE_14__["SplitPanel"]; });

/* harmony import */ var _layout_split_panel_split_widget_options__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./layout/split-panel/split-widget-options */ "./src/layout/split-panel/split-widget-options.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SplitWidgetOptions", function() { return _layout_split_panel_split_widget_options__WEBPACK_IMPORTED_MODULE_15__["SplitWidgetOptions"]; });

/* harmony import */ var _datasources_webrequest_datasource__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./datasources/webrequest-datasource */ "./src/datasources/webrequest-datasource.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WebRequestDatasourceProcessor", function() { return _datasources_webrequest_datasource__WEBPACK_IMPORTED_MODULE_16__["WebRequestDatasourceProcessor"]; });

/* harmony import */ var _components_cs_app_cs_app__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/cs-app/cs-app */ "./src/components/cs-app/cs-app.ts");
/* harmony import */ var _components_cs_widget_cs_widget__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/cs-widget/cs-widget */ "./src/components/cs-widget/cs-widget.ts");
/* harmony import */ var _components_cs_dashboard_cs_dashboard__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/cs-dashboard/cs-dashboard */ "./src/components/cs-dashboard/cs-dashboard.ts");
/* harmony import */ var _components_cs_sidebar_cs_sidebar__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/cs-sidebar/cs-sidebar */ "./src/components/cs-sidebar/cs-sidebar.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CsApp", function() { return _components_cs_app_cs_app__WEBPACK_IMPORTED_MODULE_17__["CsApp"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CsWidget", function() { return _components_cs_widget_cs_widget__WEBPACK_IMPORTED_MODULE_18__["CsWidget"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CsDashboard", function() { return _components_cs_dashboard_cs_dashboard__WEBPACK_IMPORTED_MODULE_19__["CsDashboard"]; });

/* harmony import */ var _components_cs_settings_cs_settings__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/cs-settings/cs-settings */ "./src/components/cs-settings/cs-settings.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FieldGroup", function() { return _components_cs_settings_cs_settings__WEBPACK_IMPORTED_MODULE_21__["FieldGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CsSettings", function() { return _components_cs_settings_cs_settings__WEBPACK_IMPORTED_MODULE_21__["CsSettings"]; });

/* harmony import */ var _widgets_widget_base__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./widgets/widget-base */ "./src/widgets/widget-base.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetBase", function() { return _widgets_widget_base__WEBPACK_IMPORTED_MODULE_22__["WidgetBase"]; });

/* harmony import */ var _widgets_markdown_md_widget__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./widgets/markdown/md-widget */ "./src/widgets/markdown/md-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MdWidget", function() { return _widgets_markdown_md_widget__WEBPACK_IMPORTED_MODULE_23__["MdWidget"]; });

/* harmony import */ var _widgets_markdown_md_widget_options__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./widgets/markdown/md-widget-options */ "./src/widgets/markdown/md-widget-options.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IMdWidgetOptions", function() { return _widgets_markdown_md_widget_options__WEBPACK_IMPORTED_MODULE_24__["IMdWidgetOptions"]; });

/* harmony import */ var _widgets_iframe_widget__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./widgets/iframe-widget */ "./src/widgets/iframe-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IframeWidget", function() { return _widgets_iframe_widget__WEBPACK_IMPORTED_MODULE_25__["IframeWidget"]; });

/* harmony import */ var _widgets_youtube_background_youtube_background_widget__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./widgets/youtube-background/youtube-background-widget */ "./src/widgets/youtube-background/youtube-background-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "YoutubeBackgroundWidget", function() { return _widgets_youtube_background_youtube_background_widget__WEBPACK_IMPORTED_MODULE_26__["YoutubeBackgroundWidget"]; });

/* harmony import */ var _widgets_image_widget__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./widgets/image-widget */ "./src/widgets/image-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageWidget", function() { return _widgets_image_widget__WEBPACK_IMPORTED_MODULE_27__["ImageWidget"]; });

/* harmony import */ var _widgets_svg_widget__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./widgets/svg-widget */ "./src/widgets/svg-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgWidget", function() { return _widgets_svg_widget__WEBPACK_IMPORTED_MODULE_28__["SvgWidget"]; });

/* harmony import */ var _widgets_vega_widget__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./widgets/vega-widget */ "./src/widgets/vega-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VegaWidget", function() { return _widgets_vega_widget__WEBPACK_IMPORTED_MODULE_29__["VegaWidget"]; });

/* harmony import */ var _widgets_intro_intro_widget__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./widgets/intro/intro-widget */ "./src/widgets/intro/intro-widget.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CsIntroWidget", function() { return _widgets_intro_intro_widget__WEBPACK_IMPORTED_MODULE_30__["CsIntroWidget"]; });

/* harmony import */ var _widgets_intro_intro_widget_options__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./widgets/intro/intro-widget-options */ "./src/widgets/intro/intro-widget-options.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntroWidgetOptions", function() { return _widgets_intro_intro_widget_options__WEBPACK_IMPORTED_MODULE_31__["IntroWidgetOptions"]; });

// services

// utils

// services






// layout managers









// datasources

// components








// widgets










const csnext = {
    install: (vue) => {
        const a = _services_app_state__WEBPACK_IMPORTED_MODULE_0__["AppState"].Instance;
        vue.component('cs-dashboard', _components_cs_dashboard_cs_dashboard__WEBPACK_IMPORTED_MODULE_19__["CsDashboard"]);
        vue.component('cs-widget', _components_cs_widget_cs_widget__WEBPACK_IMPORTED_MODULE_18__["CsWidget"]);
        vue.component('cs-app', _components_cs_app_cs_app__WEBPACK_IMPORTED_MODULE_17__["CsApp"]);
        vue.component('cs-sidebar', _components_cs_sidebar_cs_sidebar__WEBPACK_IMPORTED_MODULE_20__["CsSidebar"]);
    }
};


/***/ }),

/***/ "./src/layout/css-grid/css-grid.css":
/*!******************************************!*\
  !*** ./src/layout/css-grid/css-grid.css ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./css-grid.css */ "../../node_modules/css-loader/index.js!./src/layout/css-grid/css-grid.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/layout/css-grid/css-grid.html":
/*!*******************************************!*\
  !*** ./src/layout/css-grid/css-grid.html ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"css-grid-managerr\" :style=\"gridStyle()\">\n  <cs-widget v-for=\"widget in dashboard.widgets\" :key=\"widget.id\" :widget=\"widget\" :style=\"gridWidgetClass(widget)\"></cs-widget>\n</div>\n"

/***/ }),

/***/ "./src/layout/css-grid/css-grid.ts":
/*!*****************************************!*\
  !*** ./src/layout/css-grid/css-grid.ts ***!
  \*****************************************/
/*! exports provided: CssGrid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CssGrid", function() { return CssGrid; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _css_grid_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./css-grid.css */ "./src/layout/css-grid/css-grid.css");
/* harmony import */ var _css_grid_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_css_grid_css__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let CssGrid = class CssGrid extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    gridStyle() {
        if (!this.dashboard) {
            return;
        }
        const style = {};
        const options = this.dashboard.options;
        return { 'grid-template-columns': 'repeat(auto-fill, minmax(250px,1fr))' };
    }
    gridWidgetClass(widget) {
        const style = {};
        const options = widget.options;
        if (options.columnStart) {
            style['grid-column-start'] = options.columnStart;
        }
        if (options.columnEnd) {
            style['grid-column-end'] = options.columnEnd;
        }
        if (options.rowStart) {
            style['grid-row-start'] = options.rowStart;
        }
        if (options.rowEnd) {
            style['grid-row-end'] = options.rowEnd;
        }
        return style;
    }
};
CssGrid = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        template: __webpack_require__(/*! ./css-grid.html */ "./src/layout/css-grid/css-grid.html"),
        props: {
            dashboard: null
        }
    })
], CssGrid);

___WEBPACK_IMPORTED_MODULE_2__["LayoutManager"].add({
    id: 'css-grid',
    name: 'css-grid page',
    component: CssGrid
});


/***/ }),

/***/ "./src/layout/flex-grid/flex-grid-options.ts":
/*!***************************************************!*\
  !*** ./src/layout/flex-grid/flex-grid-options.ts ***!
  \***************************************************/
/*! exports provided: FlexGridOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlexGridOptions", function() { return FlexGridOptions; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

class FlexGridOptions extends _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["BaseDashboardOptions"] {
}


/***/ }),

/***/ "./src/layout/flex-grid/flex-grid.css":
/*!********************************************!*\
  !*** ./src/layout/flex-grid/flex-grid.css ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./flex-grid.css */ "../../node_modules/css-loader/index.js!./src/layout/flex-grid/flex-grid.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/layout/flex-grid/flex-grid.html":
/*!*********************************************!*\
  !*** ./src/layout/flex-grid/flex-grid.html ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-grid-manager\">\n  <cs-widget v-for=\"widget in backgroundWidgets\" :key=\"widget.id\" :widget=\"widget\" class=\"flex-background-widget\"></cs-widget>\n  <v-container fluid class=\"mx-0 pa-0\" style=\"z-index: 150; height: 100%\">\n    <v-layout v-for=\"container in containers\" :key=\"container.id\" :style=\"containerStyles(container)\" :row=\"container.options.direction === 'row'\" :column=\"container.options.direction === 'column'\" wrap>\n      <v-flex v-for=\"widget in container.widgets\" :key=\"widget.id\" :class=\"flexClasses(widget)\" style=\"z-index: 100;\" :style=\"flexStyles(widget)\">\n        <cs-widget :key=\"widget.id\" :widget=\"widget\" class=\"flex-widget\"></cs-widget>\n      </v-flex>\n    </v-layout>\n  </v-container>\n</div>\n"

/***/ }),

/***/ "./src/layout/flex-grid/flex-grid.ts":
/*!*******************************************!*\
  !*** ./src/layout/flex-grid/flex-grid.ts ***!
  \*******************************************/
/*! exports provided: FlexGrid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlexGrid", function() { return FlexGrid; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _flex_grid_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./flex-grid.css */ "./src/layout/flex-grid/flex-grid.css");
/* harmony import */ var _flex_grid_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_flex_grid_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vue-property-decorator */ "../../node_modules/vue-property-decorator/lib/vue-property-decorator.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let FlexGrid = class FlexGrid extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.containers = [];
    }
    get options() {
        return this.dashboard.options;
    }
    widgetsUpdated(n) {
        this.updateContainers();
    }
    // public containers: IFlexGridContainer[] = [];
    get backgroundWidgets() {
        if (!this.dashboard || !this.dashboard.widgets) {
            return null;
        }
        return this.dashboard.widgets.filter(w => w.options && w.options.background);
    }
    getContainer(widget) {
        if (!this.options) {
            this.dashboard.options = {};
        }
        if (!this.containers) {
            this.containers = [];
        }
        if (!widget.options) {
            widget.options = {};
        }
        if (!widget.options.container) {
            widget.options.container = 0;
        }
        const containerIndex = widget.options.container || 0;
        while (this.containers.length < containerIndex + 1) {
            this.containers.push({
                id: containerIndex,
                widgets: []
            });
        }
        if (this.options.containers &&
            this.options.containers.length >= containerIndex) {
            this.containers[containerIndex].options = this.options.containers[containerIndex];
        }
        else {
            this.containers[containerIndex].options = {
                direction: 'row' //
                // height: '300px'
            };
        }
        return this.containers[containerIndex];
    }
    updateContainers() {
        this.containers = [];
        if (!this.dashboard || !this.dashboard.widgets) {
            return;
        }
        this.dashboard.widgets
            .filter(w => !w.options || !w.options.background)
            .forEach(widget => {
            const container = this.getContainer(widget);
            container.widgets.push(widget);
        });
    }
    containerStyles(container) {
        const res = {};
        if (container.options) {
            if (container.options.height) {
                res.height = container.options.height;
            }
            if (container.options.maxHeight) {
                res['max-height'] = container.options.maxHeight;
            }
        }
        return res;
    }
    flexClasses(widget) {
        if (widget.options && widget.options.size) {
            const opt = widget.options;
            switch (opt.size) {
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].Small:
                    return 'md2 sm4 xs6';
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].Medium:
                    return 'md4 sm4 xs6';
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].Large:
                    return 'md6 sm6 xs12';
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].Tall:
                    return 'md4 sm6 xs12';
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].Wide:
                    return 'md6 sm6 xs12';
                case ___WEBPACK_IMPORTED_MODULE_2__["FlexSize"].AutoWidth:
                    return 'autowidth';
            }
        }
        // return 'autowidth';
        return 'md2 sm6 xs12';
    }
    flexStyles() {
        return { padding: '5px' };
    }
    created() {
        this.updateContainers();
    }
};
__decorate([
    Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Watch"])('dashboard.widgets'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FlexGrid.prototype, "widgetsUpdated", null);
FlexGrid = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        template: __webpack_require__(/*! ./flex-grid.html */ "./src/layout/flex-grid/flex-grid.html"),
        props: {
            dashboard: null
        }
    })
], FlexGrid);

___WEBPACK_IMPORTED_MODULE_2__["LayoutManager"].add({
    id: 'flex-grid',
    name: 'flex-grid page',
    component: FlexGrid
});


/***/ }),

/***/ "./src/layout/flex-grid/flex-size.ts":
/*!*******************************************!*\
  !*** ./src/layout/flex-grid/flex-size.ts ***!
  \*******************************************/
/*! exports provided: FlexSize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlexSize", function() { return FlexSize; });
var FlexSize;
(function (FlexSize) {
    FlexSize["Small"] = "Small";
    FlexSize["Medium"] = "Medium";
    FlexSize["Large"] = "Large";
    FlexSize["Wide"] = "Wide";
    FlexSize["Tall"] = "Tall";
    FlexSize["AutoWidth"] = "AutoWidth";
})(FlexSize || (FlexSize = {}));


/***/ }),

/***/ "./src/layout/flex-grid/flex-widget-options.ts":
/*!*****************************************************!*\
  !*** ./src/layout/flex-grid/flex-widget-options.ts ***!
  \*****************************************************/
/*! exports provided: FlexWidgetOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlexWidgetOptions", function() { return FlexWidgetOptions; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

class FlexWidgetOptions extends _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["WidgetOptions"] {
}


/***/ }),

/***/ "./src/layout/grid/grid.css":
/*!**********************************!*\
  !*** ./src/layout/grid/grid.css ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./grid.css */ "../../node_modules/css-loader/index.js!./src/layout/grid/grid.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/layout/grid/grid.html":
/*!***********************************!*\
  !*** ./src/layout/grid/grid.html ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-manager\">\n  <cs-widget v-for=\"widget in dashboard.widgets\" :key=\"widget.id\" :widget=\"widget\"></cs-widget>\n</div>\n"

/***/ }),

/***/ "./src/layout/grid/grid.ts":
/*!*********************************!*\
  !*** ./src/layout/grid/grid.ts ***!
  \*********************************/
/*! exports provided: Grid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return Grid; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _grid_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./grid.css */ "./src/layout/grid/grid.css");
/* harmony import */ var _grid_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_grid_css__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let Grid = class Grid extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
};
Grid = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        template: __webpack_require__(/*! ./grid.html */ "./src/layout/grid/grid.html"),
        props: {
            dashboard: null
        }
    })
], Grid);

___WEBPACK_IMPORTED_MODULE_2__["LayoutManager"].add({
    id: 'grid',
    name: 'grid page',
    component: Grid
});


/***/ }),

/***/ "./src/layout/single/single.css":
/*!**************************************!*\
  !*** ./src/layout/single/single.css ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./single.css */ "../../node_modules/css-loader/index.js!./src/layout/single/single.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/layout/single/single.html":
/*!***************************************!*\
  !*** ./src/layout/single/single.html ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard-single\">\r\n  <cs-widget v-if=\"widget\" :widget=\"widget\"></cs-widget>\r\n</div>\r\n"

/***/ }),

/***/ "./src/layout/single/single.ts":
/*!*************************************!*\
  !*** ./src/layout/single/single.ts ***!
  \*************************************/
/*! exports provided: Single */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Single", function() { return Single; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var _single_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./single.css */ "./src/layout/single/single.css");
/* harmony import */ var _single_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_single_css__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let Single = 
/** Single layout manager. Only shows first widget full screen */
class Single extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super(...arguments);
        this.widgetAvailable = false;
    }
    created() {
        if (!this.dashboard || !this.dashboard.widgets || this.dashboard.widgets.length === 0) {
            return;
        }
        this.widget = this.dashboard.widgets.find(w => !w.hasOwnProperty('sideNav'));
        this.widgetAvailable = false;
    }
};
Single = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'single',
        template: __webpack_require__(/*! ./single.html */ "./src/layout/single/single.html"),
        props: {
            dashboard: null
        }
    })
    /** Single layout manager. Only shows first widget full screen */
], Single);

___WEBPACK_IMPORTED_MODULE_2__["LayoutManager"].add({ id: 'single', name: 'single page', component: Single });


/***/ }),

/***/ "./src/layout/split-panel/split-panel.css":
/*!************************************************!*\
  !*** ./src/layout/split-panel/split-panel.css ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./split-panel.css */ "../../node_modules/css-loader/index.js!./src/layout/split-panel/split-panel.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/layout/split-panel/split-panel.html":
/*!*************************************************!*\
  !*** ./src/layout/split-panel/split-panel.html ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"split-manager\">\n  <Split style=\"height: 100%; width: 100%\" ref=\"mySplit\">\n    <SplitArea v-for=\"widget in dashboard.widgets\" :key=\"widget.id\" :size=\"widget.options.width\">\n      <cs-widget :widget=\"widget\"></cs-widget>\n    </SplitArea>\n  </Split>\n</div>\n"

/***/ }),

/***/ "./src/layout/split-panel/split-panel.ts":
/*!***********************************************!*\
  !*** ./src/layout/split-panel/split-panel.ts ***!
  \***********************************************/
/*! exports provided: SplitPanel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SplitPanel", function() { return SplitPanel; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var vue_split_panel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-split-panel */ "../../node_modules/vue-split-panel/dist/vue-split-panel.js");
/* harmony import */ var vue_split_panel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_split_panel__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _split_panel_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./split-panel.css */ "./src/layout/split-panel/split-panel.css");
/* harmony import */ var _split_panel_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_split_panel_css__WEBPACK_IMPORTED_MODULE_4__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let SplitPanel = class SplitPanel extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    mounted() {
        setTimeout(() => {
            console.log(this.$refs.mySplit.getSizes());
        }, 2000);
    }
};
SplitPanel = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        template: __webpack_require__(/*! ./split-panel.html */ "./src/layout/split-panel/split-panel.html"),
        props: {
            dashboard: null
        }
    })
], SplitPanel);

vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(vue_split_panel__WEBPACK_IMPORTED_MODULE_3___default.a);
___WEBPACK_IMPORTED_MODULE_2__["LayoutManager"].add({
    id: 'split-panel',
    name: 'split panels',
    component: SplitPanel
});


/***/ }),

/***/ "./src/layout/split-panel/split-widget-options.ts":
/*!********************************************************!*\
  !*** ./src/layout/split-panel/split-widget-options.ts ***!
  \********************************************************/
/*! exports provided: SplitWidgetOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SplitWidgetOptions", function() { return SplitWidgetOptions; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

class SplitWidgetOptions extends _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["WidgetOptions"] {
}


/***/ }),

/***/ "./src/services/app-state.ts":
/*!***********************************!*\
  !*** ./src/services/app-state.ts ***!
  \***********************************/
/*! exports provided: AppState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppState", function() { return AppState; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _project_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./project-manager */ "./src/services/project-manager.ts");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ */ "./src/index.ts");
/* harmony import */ var _default_project__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./default-project */ "./src/services/default-project.ts");


// tslint:disable-next-line:no-var-requires
const deepmerge = __webpack_require__(/*! deepmerge */ "../../node_modules/deepmerge/dist/es.js").default;



/** AppState is a singleton class used for project defintion, keeping track of available dashboard managers and datasource handlers. It also includes a generic EventBus and logger instance */
// TODO Should we use idiomatic Typescript instead, as in
// https://github.com/Badacadabra/JavaScript-Design-Patterns/blob/master/GoF/idiomatic/Creational/Singleton/TypeScript/API/me.ts
class AppState {
    constructor() {
        /** Project definition */
        this.project = {};
        /** Logger */
        this.logger = ___WEBPACK_IMPORTED_MODULE_3__["Logger"].Instance;
        /** Event bus for publish/subscribe events in application */
        this.bus = new _csnext_cs_core__WEBPACK_IMPORTED_MODULE_1__["MessageBusService"]();
        /** True if the application has been initialized */
        this.isInitialized = false;
        /** list of past notifications */
        this.notifications = [];
        this.data = {};
        this.windowSize = { x: 0, y: 0 };
    }
    /** Get singleton instance of appstate */
    static get Instance() {
        return this.pInstance || (this.pInstance = new this());
    }
    /** Initialize the project state, dashboard managers and data summaries handlers */
    init(project) {
        ___WEBPACK_IMPORTED_MODULE_3__["Logger"].info('app-state', 'Init AppState');
        // init basic common sense components
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('cs-dashboard', ___WEBPACK_IMPORTED_MODULE_3__["CsDashboard"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('cs-widget', ___WEBPACK_IMPORTED_MODULE_3__["CsWidget"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('cs-app', ___WEBPACK_IMPORTED_MODULE_3__["CsApp"]);
        // merge new project details, with default project to make sure all required properties are available
        this.project = deepmerge(_default_project__WEBPACK_IMPORTED_MODULE_4__["DefaultProject"], project);
        // check if navigation style requires a leftSidebar, add one if not available
        if (this.project.navigation &&
            this.project.navigation.style &&
            ['left', 'left-hierarchy'].includes(this.project.navigation.style) &&
            !this.project.leftSidebar) {
            this.project.leftSidebar = {
                open: false,
                mini: false,
                clipped: true,
                permanent: false,
                temporary: true
            };
        }
        // make sure all dashboards are marked as main
        if (this.project.dashboards) {
            this.initializeDashboards(this.project.dashboards);
        }
        // setup project manager
        this.projectManager = new _project_manager__WEBPACK_IMPORTED_MODULE_2__["ProjectManager"](project);
        // mark app as initialized
        this.isInitialized = true;
        this.bus.publish('app-state', 'init', null);
    }
    /** loads specific datasource in memory. Returns selected datasource as a promise  */
    loadDatasource(source) {
        if (!this.projectManager) {
            return Promise.reject('Project Manager not initialized');
        }
        return this.projectManager.datasourceManager.load(source);
    }
    /** Triggers notification */
    TriggerNotification(notification) {
        Object.assign(notification, {
            id: Object(___WEBPACK_IMPORTED_MODULE_3__["guidGenerator"])(),
            timeout: 3000,
            created: new Date(),
            isRead: false,
            remember: true,
            _visible: true
        });
        this.bus.publish('notification', 'new', notification);
        if (this.project.notifications &&
            this.project.notifications.items &&
            notification.remember) {
            this.project.notifications.items.push(notification);
        }
    }
    TriggerDialog(dialog) {
        this.bus.publish('dialog', 'new', dialog);
    }
    /** if rightsidebar exists, clear component and close */
    ClearRightSidebar() {
        if (this.project.rightSidebar &&
            this.project.rightSidebar.dashboard &&
            this.project.rightSidebar.dashboard.widgets) {
            while (this.project.rightSidebar.dashboard.widgets.length > 0) {
                this.project.rightSidebar.dashboard.widgets.pop();
            }
            this.project.rightSidebar.open = false;
        }
    }
    /** If a rightsidebar exists, it will replaces all rightsidebar content with this specific widget */
    OpenRightSidebarWidget(widget, options) {
        if (this.project.rightSidebar &&
            this.project.rightSidebar.dashboard &&
            this.project.rightSidebar.dashboard.widgets) {
            while (this.project.rightSidebar.dashboard.widgets.length > 0) {
                this.project.rightSidebar.dashboard.widgets.pop();
            }
            this.project.rightSidebar.dashboard.widgets.push(widget);
            if (options) {
                if (options.open) {
                    this.project.rightSidebar.open = options.open;
                }
            }
            else {
                this.project.rightSidebar.open = true;
            }
        }
    }
    /** initializes given dashboards */
    initializeDashboards(dashboards) {
        if (dashboards) {
            dashboards.forEach(d => {
                d.isMain = true;
                if (!d.pathLink) {
                    d.pathLink = d.path;
                }
                if (d.dashboards) {
                    this.initializeDashboards(d.dashboards);
                }
            });
        }
    }
}


/***/ }),

/***/ "./src/services/dashboard-manager.ts":
/*!*******************************************!*\
  !*** ./src/services/dashboard-manager.ts ***!
  \*******************************************/
/*! exports provided: DashboardManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardManager", function() { return DashboardManager; });
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./logger */ "./src/services/logger.ts");

// TODO Is this the correct name, since it only stores a reference to existing dashboard managers, and doesn't do any management.
class DashboardManager {
    /** Registration of a new dashboard manager */
    static add(manager) {
        const managers = DashboardManager.dashboardManagers;
        if (managers && !managers.hasOwnProperty(manager.id)) {
            _logger__WEBPACK_IMPORTED_MODULE_0__["Logger"].info('dashboard manager', 'added ' + manager.id);
            DashboardManager.dashboardManagers[manager.id] = manager;
        }
    }
}
// TODO Make private (only reference is in the csdashboard.ts)
/** Available dashboard managers for layouting */
DashboardManager.dashboardManagers = {};


/***/ }),

/***/ "./src/services/datasource-manager.ts":
/*!********************************************!*\
  !*** ./src/services/datasource-manager.ts ***!
  \********************************************/
/*! exports provided: DatasourceManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatasourceManager", function() { return DatasourceManager; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

/**
 * The DatasourceManager maintains a list of all datasource processors and all datasources?.
 */
class DatasourceManager {
    constructor(datasources) {
        this.datasources = datasources;
    }
    /** Registration of a new data source handler */
    static add(processor) {
        DatasourceManager.Processors[processor.id] = processor;
    }
    /** Load a data source using the assigned data summary handler(s) */
    load(source) {
        const datasource = typeof source === 'string' ? this.datasources[source] : source;
        const handlers = datasource.handlers;
        if (!handlers && datasource.loaded) {
            return new Promise((resolve, reject) => {
                resolve(datasource);
                return;
            });
        }
        if (typeof datasource.execute !== 'function') {
            return new Promise(resolve => {
                resolve(datasource);
                return;
            });
        }
        if (!handlers && datasource.data) {
            return new Promise((resolve, reject) => {
                resolve(datasource.data);
                return;
            });
        }
        // if (typeof datasource.execute === 'function' && datasource.loaded) {
        //   return new Promise((resolve, reject) => {
        //     resolve(datasource as any);
        //     return;
        //   });
        // }
        // run processors
        return new Promise((resolve, reject) => {
            if (datasource.data && datasource.loaded) {
                resolve(datasource.data);
                return;
            }
            // if datasource is already being loaded added promise to queue
            if (datasource.isLoading) {
                if (!datasource.requestQueue) {
                    datasource.requestQueue = [];
                }
                datasource.requestQueue.push({ resolve, reject });
                return;
            }
            datasource.isLoading = true;
            if (typeof datasource.execute === 'function') {
                datasource
                    .execute(this.datasources)
                    .catch(e => {
                    datasource.loaded = false;
                    datasource.isLoading = false;
                })
                    .then(r => {
                    datasource.loaded = true;
                    datasource.isLoading = false;
                    resolve(r);
                    while (datasource.requestQueue &&
                        datasource.requestQueue.length > 0) {
                        const item = datasource.requestQueue.pop();
                        if (item) {
                            item.resolve(r);
                        }
                    }
                });
            }
            else if (handlers) {
                handlers
                    .reduce((promise, current) => {
                    let dsProcessor;
                    if (DatasourceManager.Processors.hasOwnProperty(current.processorId)) {
                        dsProcessor = DatasourceManager.Processors[current.processorId];
                        // throw new Error(
                        //   `DatasourceProcessor ${current.processorId} is not registered!`
                        // );
                    }
                    else {
                        dsProcessor = current._processor;
                    }
                    if (!dsProcessor) {
                        throw new Error(`DatasourceProcessor ${current.processorId} is not registered!`);
                    }
                    return promise.then(result => {
                        return dsProcessor.execute(this.datasources, datasource, _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["ProcessorActions"].Read, result);
                    });
                }, Promise.resolve())
                    .catch(e => {
                    datasource.loaded = false;
                    datasource.isLoading = false;
                    reject();
                    // resolve promises for queued promises
                    while (datasource.requestQueue &&
                        datasource.requestQueue.length > 0) {
                        const item = datasource.requestQueue.pop();
                        if (item) {
                            item.reject();
                        }
                    }
                })
                    .then(result => {
                    datasource.data = result; // Save the data as part of the datasource
                    datasource.loaded = true;
                    datasource.isLoading = false;
                    resolve(result);
                    // resolve promises for queued promises
                    while (datasource.requestQueue &&
                        datasource.requestQueue.length > 0) {
                        const item = datasource.requestQueue.pop();
                        if (item) {
                            item.resolve(result);
                        }
                    }
                });
            }
        });
    }
    /** load all data sources */
    loadAll() {
        if (!this.datasources) {
            return;
        }
        for (const ds in this.datasources) {
            if (!this.datasources.hasOwnProperty(ds)) {
                continue;
            }
            const source = this.datasources[ds];
            this.load(source);
        }
    }
}
/** Available datasource handlers  */
DatasourceManager.Processors = {};


/***/ }),

/***/ "./src/services/default-project.ts":
/*!*****************************************!*\
  !*** ./src/services/default-project.ts ***!
  \*****************************************/
/*! exports provided: DefaultProject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultProject", function() { return DefaultProject; });
const DefaultProject = {
    header: {
        title: 'Test project',
        breadcrumbs: false,
        dense: false
    },
    navigation: {
        style: 'tabs'
    },
    // leftSidebar: {
    //   open: false,
    //   mini: false,
    //   clipped: true,
    //   permanent: false,
    //   temporary: true
    //   // dashboard: {
    //   //   widgets: []
    //   // }
    // },
    datasources: {},
    theme: {
        dark: false,
        colors: {
            primary: '#F44336',
            secondary: '#E57373',
            accent: '#82B1FF',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107',
            menu: '#000'
        }
    },
    // footer: {
    //   visible: false,
    //   dashboard: {
    //     widgets: []
    //   }
    // },
    // rightSidebar: {
    //   open: false,
    //   right: true,
    //   clipped: false,
    //   temporary: false,
    //   dashboard: {
    //     widgets: []
    //   }
    // },
    menus: [],
    dashboards: []
};


/***/ }),

/***/ "./src/services/layout-manager.ts":
/*!****************************************!*\
  !*** ./src/services/layout-manager.ts ***!
  \****************************************/
/*! exports provided: LayoutManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutManager", function() { return LayoutManager; });
// TODO Is this the correct name, since it only stores a reference to existing dashboard managers, and doesn't do any management.
class LayoutManager {
    /** Registration of a new dashboard manager */
    static add(manager) {
        LayoutManager.layoutManagers[manager.id] = manager;
    }
    static addLayoutManager(comp) {
        if (comp.hasOwnProperty('id')) {
            const manager = { id: comp.id, name: comp.id, component: comp };
            LayoutManager.add(manager);
        }
    }
}
// TODO Make private (only reference is in the csdashboard.ts)
/** Available dashboard managers for layouting */
LayoutManager.layoutManagers = {};


/***/ }),

/***/ "./src/services/logger.ts":
/*!********************************!*\
  !*** ./src/services/logger.ts ***!
  \********************************/
/*! exports provided: Logger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
class Logger {
    static info(component, msg) {
        // tslint:disable-next-line:no-console
        console.info('[' + component + ']', msg);
    }
    static warn(component, msg) {
        // tslint:disable-next-line:no-console
        console.info('[' + component + ']', msg);
    }
    static error(component, msg) {
        // tslint:disable-next-line:no-console
        console.info('[' + component + ']', msg);
    }
    static get Instance() {
        // Do you need arguments? Make it a regular method instead.
        return this.instance || (this.instance = new this());
    }
}


/***/ }),

/***/ "./src/services/project-manager.ts":
/*!*****************************************!*\
  !*** ./src/services/project-manager.ts ***!
  \*****************************************/
/*! exports provided: ProjectManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectManager", function() { return ProjectManager; });
/* harmony import */ var _dashboard_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dashboard-manager */ "./src/services/dashboard-manager.ts");
/* harmony import */ var _layout_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./layout-manager */ "./src/services/layout-manager.ts");
/* harmony import */ var _datasource_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./datasource-manager */ "./src/services/datasource-manager.ts");



class ProjectManager {
    constructor(project = {}) {
        this.project = project;
        if (!project.datasources) {
            project.datasources = {};
        }
        if (!project.header) {
            project.header = {};
        }
        if (!project.notifications) {
            project.notifications = {};
        }
        Object.assign(project.notifications, { enabled: false, items: [], listStyle: 'popup' });
        this.datasourceManager = new _datasource_manager__WEBPACK_IMPORTED_MODULE_2__["DatasourceManager"](project.datasources);
        this.dashboardManager = new _dashboard_manager__WEBPACK_IMPORTED_MODULE_0__["DashboardManager"]();
        this.layoutManager = new _layout_manager__WEBPACK_IMPORTED_MODULE_1__["LayoutManager"]();
    }
}


/***/ }),

/***/ "./src/utils/guid.ts":
/*!***************************!*\
  !*** ./src/utils/guid.ts ***!
  \***************************/
/*! exports provided: guidGenerator, idGenerator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "guidGenerator", function() { return guidGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "idGenerator", function() { return idGenerator; });
function guidGenerator() {
    const S4 = () => {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}
function idGenerator() {
    const S4 = () => {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4());
}


/***/ }),

/***/ "./src/widgets/iframe-widget.ts":
/*!**************************************!*\
  !*** ./src/widgets/iframe-widget.ts ***!
  \**************************************/
/*! exports provided: IframeWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IframeWidget", function() { return IframeWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let IframeWidget = class IframeWidget extends ___WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
};
IframeWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'iframe-widget',
        template: '<iframe :src="widget.data.url" width="100%" height="100%" frameborder="0"></iframe>'
    })
], IframeWidget);



/***/ }),

/***/ "./src/widgets/image-widget.ts":
/*!*************************************!*\
  !*** ./src/widgets/image-widget.ts ***!
  \*************************************/
/*! exports provided: ImageWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageWidget", function() { return ImageWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../index */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ImageWidget = class ImageWidget extends _index__WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
};
ImageWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'image-widget',
        template: '<img :src="widget.data.src" style="width:100%;height: 100%"></img>'
    })
], ImageWidget);



/***/ }),

/***/ "./src/widgets/intro/intro-widget-options.ts":
/*!***************************************************!*\
  !*** ./src/widgets/intro/intro-widget-options.ts ***!
  \***************************************************/
/*! exports provided: IntroWidgetOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntroWidgetOptions", function() { return IntroWidgetOptions; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

/** Markdown widget options, from vue-markdown (https://github.com/miaolz123/vue-markdown) */
class IntroWidgetOptions extends _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["WidgetOptions"] {
}


/***/ }),

/***/ "./src/widgets/intro/intro-widget.css":
/*!********************************************!*\
  !*** ./src/widgets/intro/intro-widget.css ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./intro-widget.css */ "../../node_modules/css-loader/index.js!./src/widgets/intro/intro-widget.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/widgets/intro/intro-widget.html":
/*!*********************************************!*\
  !*** ./src/widgets/intro/intro-widget.html ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div style=\"height:100vh\">\r\n  <v-jumbotron :src=\"options.backgroundImage\">\r\n    <v-container fill-height>\r\n      <v-layout align-center>\r\n        <v-flex>\r\n          <h3 class=\"display-3\">{{options.title}}</h3>\r\n\r\n          <span class=\"subheading\">{{ options.subHeader}}</span>\r\n\r\n          <!-- <v-btn class=\"mx-0\" large>Learn more</v-btn> -->\r\n        </v-flex>\r\n      </v-layout>\r\n    </v-container>\r\n  </v-jumbotron>\r\n  <v-container grid-list-lg>\r\n    <v-layout wrap v-if=\"options.cards\">\r\n      <v-flex xs12 sm6 md4 lg3 v-for=\"card in options.cards\" :key=\"card.title\">\r\n        <v-card>\r\n          <v-img :src=\"card.backgroundImage\" height=\"200px\"></v-img>\r\n\r\n          <v-card-title primary-title>\r\n            <div>\r\n              <h3 class=\"headline mb-0\">{{card.title}}</h3>\r\n              <div></div>\r\n            </div>\r\n          </v-card-title>\r\n\r\n          <v-card-actions v-if=\"card.actions\" >\r\n            <template v-for=\"action in card.actions\">\r\n              <v-btn v-if=\"action.route\" :to=\"action.route\" flat color=\"orange\">{{action.title}}</v-btn>\r\n              <v-btn v-else :href=\"action.url\" flat color=\"orange\">{{action.title}}</v-btn>\r\n            </template>\r\n          </v-card-actions>\r\n        </v-card>\r\n      </v-flex>\r\n    </v-layout>\r\n  </v-container>\r\n</div>\r\n"

/***/ }),

/***/ "./src/widgets/intro/intro-widget.ts":
/*!*******************************************!*\
  !*** ./src/widgets/intro/intro-widget.ts ***!
  \*******************************************/
/*! exports provided: CsIntroWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CsIntroWidget", function() { return CsIntroWidget; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _intro_widget_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./intro-widget.css */ "./src/widgets/intro/intro-widget.css");
/* harmony import */ var _intro_widget_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_intro_widget_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




let CsIntroWidget = class CsIntroWidget extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this.app = ___WEBPACK_IMPORTED_MODULE_3__["AppState"].Instance;
    }
    get options() {
        if (!this.widget || !this.widget.options) {
            return undefined;
        }
        return this.widget.options;
    }
};
CsIntroWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'cs-intro-widget',
        template: __webpack_require__(/*! ./intro-widget.html */ "./src/widgets/intro/intro-widget.html"),
        props: {
            widget: null
        }
    }),
    __metadata("design:paramtypes", [])
], CsIntroWidget);



/***/ }),

/***/ "./src/widgets/markdown/md-widget-options.ts":
/*!***************************************************!*\
  !*** ./src/widgets/markdown/md-widget-options.ts ***!
  \***************************************************/
/*! exports provided: IMdWidgetOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMdWidgetOptions", function() { return IMdWidgetOptions; });
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @csnext/cs-core */ "../cs-core/dist/index.js");
/* harmony import */ var _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__);

/** Markdown widget options, from vue-markdown (https://github.com/miaolz123/vue-markdown) */
class IMdWidgetOptions extends _csnext_cs_core__WEBPACK_IMPORTED_MODULE_0__["WidgetOptions"] {
}


/***/ }),

/***/ "./src/widgets/markdown/md-widget.ts":
/*!*******************************************!*\
  !*** ./src/widgets/markdown/md-widget.ts ***!
  \*******************************************/
/*! exports provided: MdWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MdWidget", function() { return MdWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../ */ "./src/index.ts");
/* harmony import */ var vue_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-markdown */ "vue-markdown");
/* harmony import */ var vue_markdown__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_markdown__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let MdWidget = class MdWidget extends ___WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
    mounted() {
        // tslint:disable-next-line:no-debugger
        // debugger;
    }
};
MdWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'md-widget',
        components: { VueMarkdown: (vue_markdown__WEBPACK_IMPORTED_MODULE_2___default()) },
        template: '<VueMarkdown :source="widget.data" :emoji="widget.options.emoji" :linkify="widget.options.linkify" :breaks="widget.options.break" :html="widget.options.html"></VueMarkdown>'
    })
], MdWidget);



/***/ }),

/***/ "./src/widgets/svg-widget.ts":
/*!***********************************!*\
  !*** ./src/widgets/svg-widget.ts ***!
  \***********************************/
/*! exports provided: SvgWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgWidget", function() { return SvgWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SvgWidget = class SvgWidget extends ___WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
};
SvgWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'svg-widget',
        template: '<img :src="widget.data.path"></img>'
    })
], SvgWidget);



/***/ }),

/***/ "./src/widgets/vega-widget.ts":
/*!************************************!*\
  !*** ./src/widgets/vega-widget.ts ***!
  \************************************/
/*! exports provided: VegaWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VegaWidget", function() { return VegaWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _widget_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./widget-base */ "./src/widgets/widget-base.ts");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let VegaWidget = class VegaWidget extends _widget_base__WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
    mounted() {
        vue__WEBPACK_IMPORTED_MODULE_2___default.a.nextTick(() => {
            // check if path for definition is available
            if (this.widget && this.widget.data && this.widget.data.path) {
                vega
                    .loader()
                    .load(this.widget.data.path)
                    .then((data) => {
                    this.viewRender(JSON.parse(data));
                });
            }
        });
    }
    viewRender(spec) {
        vue__WEBPACK_IMPORTED_MODULE_2___default.a.nextTick(() => {
            if (!this.widget || !this.widget.id) {
                return;
            }
            if (!spec.autosize) {
                if (!spec.width) {
                    spec.width = this.$el.clientWidth - 50;
                }
                if (!spec.height) {
                    spec.height = this.$el.clientHeight - 50;
                }
            }
            this.view = new vega.View(vega.parse(spec))
                .renderer('canvas') // set renderer (canvas or svg)
                .initialize('#vega-' + this.widget.id) // initialize view within parent DOM container
                .hover() // enable hover encode set processing
                .run();
        });
    }
};
VegaWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'vega-widget',
        template: '<div :id="\'vega-\' + widget.id"></div>'
    })
], VegaWidget);



/***/ }),

/***/ "./src/widgets/widget-base.ts":
/*!************************************!*\
  !*** ./src/widgets/widget-base.ts ***!
  \************************************/
/*! exports provided: WidgetBase */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetBase", function() { return WidgetBase; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ */ "./src/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let WidgetBase = class WidgetBase extends vue__WEBPACK_IMPORTED_MODULE_0___default.a {
    beforeMount() {
        if (!this.widget) {
            return;
        }
        ___WEBPACK_IMPORTED_MODULE_2__["Logger"].info('widget', 'init widget - ' + this.widget.id);
    }
};
WidgetBase = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
        name: 'widget-base',
        props: {
            widget: null
        }
    })
], WidgetBase);



/***/ }),

/***/ "./src/widgets/youtube-background/youtube-background-widget.css":
/*!**********************************************************************!*\
  !*** ./src/widgets/youtube-background/youtube-background-widget.css ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!./youtube-background-widget.css */ "../../node_modules/css-loader/index.js!./src/widgets/youtube-background/youtube-background-widget.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/widgets/youtube-background/youtube-background-widget.ts":
/*!*********************************************************************!*\
  !*** ./src/widgets/youtube-background/youtube-background-widget.ts ***!
  \*********************************************************************/
/*! exports provided: YoutubeBackgroundWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YoutubeBackgroundWidget", function() { return YoutubeBackgroundWidget; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-class-component */ "../../node_modules/vue-class-component/dist/vue-class-component.common.js");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _youtube_background_widget_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./youtube-background-widget.css */ "./src/widgets/youtube-background/youtube-background-widget.css");
/* harmony import */ var _youtube_background_widget_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_youtube_background_widget_css__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let YoutubeBackgroundWidget = class YoutubeBackgroundWidget extends ___WEBPACK_IMPORTED_MODULE_1__["WidgetBase"] {
};
YoutubeBackgroundWidget = __decorate([
    vue_class_component__WEBPACK_IMPORTED_MODULE_0___default()({
        name: 'youtube-background-widget',
        template: '<div class="video-background"><div class="video-foreground"><iframe :src="\'https://www.youtube.com/embed/\' + widget.data.id + \'?rel=0&amp;controls=0&amp;showinfo=0&autoplay=1\'" frameborder=0 allowfullscreen></iframe></div></div>'
    })
], YoutubeBackgroundWidget);



/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/index.ts */"./src/index.ts");


/***/ }),

/***/ "vue":
/*!**********************!*\
  !*** external "Vue" ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;

/***/ }),

/***/ "vue-markdown":
/*!*******************************!*\
  !*** external "vue-markdown" ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_markdown__;

/***/ })

/******/ });
});
//# sourceMappingURL=csclient.cs.js.map